
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import classes from "./CustomDataForm.module.scss";
import * as CustomConfig from "Flow2/components/CustomCollections/CustomDataConfig/CustomDataConfig";
import CustomTypes from "Flow2/components/CustomCollections/CustomDataConfig/CustomDataTypes";
import * as DataUtil from "Flow2/components/CustomCollections/CustomDataUtil/CustomDataUtil";
import CustomEvents from 'Flow2/components/CustomCollections/CustomDataConfig/CustomAppEvents';
import { CustomAppEventListener, isNLW, isFrancetv, isPorscheArchiv, isDZA } from 'Flow2/components/CustomCollections/CustomDataControllers/CustomAppController.js';
import * as fh from 'Flow2/components/Share/FlexSearch/FlexSearchHelper/FlexSearchHelper';
import FlexSearchSave from 'Flow2/components/Share/FlexSearch/FlexSearchSave/FlexSearchSave';
import * as CustomForm from 'Flow2/components/CustomCollections/CustomDataControllers/CustomFormController';
import * as CustomDataBox from "Flow2/components/CustomCollections/CustomBox/CustomDataBox/CustomDataBox";
import * as actions from "store/actions/index";
import { delay } from "q";
import { showLogFile, getLogDate } from "Flow2/components/CustomCollections/CustomDataLog/CustomDataLog";
import { StockWindow } from "Flow2/components/TagsTree/TagTreeDynamic";
import TypeFilter from 'Flow2/components/Filters/TypeFilter/TypeFilter';
import * as fTypes from "Flow2/components/Share/FlexUpload/FlexUploadConfig/FlexUploadTypes";
import FlexDate from 'Flow2/components/Share/FlexGroup/FlexDate/FlexDate';
import PH from 'Flow2/util/MetadataPermissionHelper.js';
import * as Controls from 'Flow2/config/Controls';
import SweetAlert from 'sweetalert2';

class CustomDataForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            customdisplay_apptmp: "customdisplay",
            customdisplay_tmp: "customdisplayextends",
            appSubFormSectionShow: true,
            left_count: 2,
            isMetadataUpdated: false,
            allClosed: false,
            isSubmenu: false,
            isDeleted: false,
            btnBgColor: '#E2E2E2',
            aborted: false,
            files: [],
            uploadStatus: "none",
            fileId: 0,
            isPressed: false,
            unlimitedMessageBox: "none",
            isDataUpdated: false,
            shouldClose: false,
            formCancelling: false,
            appFormCloseMsg: false,
            customDataObjects: {
                selectedObjects: [],
                file: null,
                oneClip: false,
            },
            pUploaded: this.getUploadInfoId()
        };
    }

    nologoutinterval = null;

    getUploadInfoId = () => {
        if (DataUtil.isUpMaster(this.props.formDesign)) {
            return `pUploaded${this.props.formDesign}`
        }
        return "pUploaded";
    }

    setOriginalObject = () => {
        this.setState({
            originalObject: DataUtil.convertObjectToString(this.state.customDataObjects),
        });
    }

    setGrantingObj = () => {
        // return this.props.user.role === CustomTypes.ROLE_LEVEL3
        //     ? {
        //         [`${CustomTypes.GRANTING_FIELD}`]: CustomTypes.GRANTING_VALUE,
        //         [`${CustomTypes.GRANTING_FIELD}_tmp`]: this.props.intl.formatMessage({ id: `metadata.clip.state.dropdown.${CustomTypes.GRANTING_VALUE}` })
        //     } : null;
        return false;
    }

    checkAndGetShareUploadObj = () => {
        const { shareUpload } = this.props.shareObjects;
        let shareUpCurrent = {};
        if (shareUpload.current && shareUpload.clicked) {
            shareUpCurrent = { ...shareUpload.current };
            this.props.updateShareObjects({ shareUpload: { ...shareUpload, clicked: false, shouldReload: true } });
        }
        return shareUpCurrent;
    }

    setupUploadObj = () => {
        try {
            let { customDataObjects } = this.state;
            const { uploadedObj } = this.props;
            const { lastuploaddata } = this.props.user.granting.udo;
            let uploadedObjects = {};
            if (uploadedObj) {
                uploadedObjects = { ...uploadedObj };
            }
            else {
                uploadedObjects = { ...lastuploaddata } || {};
                uploadedObjects.selectedObjects = [];
                this.props.uploadSaveUploadedData(uploadedObjects);
            }

            const originalselectedObjects = [...uploadedObjects.selectedObjects];
            let fileId;
            if (uploadedObjects.selectedObjects) {
                fileId = uploadedObjects.selectedObjects.length;
                this.setState({ fileId: fileId });
            }

            let setOriginalObjects = () => {
                this.setState({
                    originalObject: DataUtil.convertObjectToString(this.state.customDataObjects),
                    originalselectedObjects: originalselectedObjects
                });
            }
            if (uploadedObjects[`${CustomConfig.customrights.name}Items`]) this.toggleRestrictionsHidden(uploadedObjects[`${CustomConfig.customrights.name}Items`]);
            let grantingObjects = this.setGrantingObj();
            //Project/Room Upload
            let shareUpCurrent = this.checkAndGetShareUploadObj();
            if (grantingObjects) {
                this.setState({
                    ...uploadedObjects, ...grantingObjects, ...shareUpCurrent,
                    customDataObjects: { ...customDataObjects, ...uploadedObjects, ...grantingObjects, ...shareUpCurrent }
                }, () => setOriginalObjects());
            }
            else {
                this.setState({
                    ...uploadedObjects, ...shareUpCurrent,
                    customDataObjects: { ...customDataObjects, ...uploadedObjects, ...shareUpCurrent }
                }, () => setOriginalObjects());
            }

        } catch (error) {
            console.log("ERROR: setupUploadObj!");
        }
    }

    setupSearchObj = () => {
        let searchedObjects = {};
        const { searchedObj } = this.props;
        const { lastsearchdata } = this.props.user.granting.udo;
        //console.log("LOGS: LAMTEST lastsearchdata", lastsearchdata);
        if (searchedObj) {
            searchedObjects = { ...searchedObj };
            if (isPorscheArchiv() && searchedObj.stock_ids) {
                searchedObjects.stock = searchedObjects.stock ? searchedObjects.stock : searchedObj.stock_ids;
                searchedObjects.stock_ids = searchedObj.stock_ids;
            }
        }
        else {
            if (lastsearchdata) {
                searchedObjects = { ...lastsearchdata };
                if (isPorscheArchiv()) {
                    searchedObjects = fh.setUpFlexSearch({ searchedObjects, lastsearchdata, formConfig: this.props.formConfig });
                }
                this.props.expertSearchSaveData(searchedObjects);
            }
        }
        let obj_tmp = DataUtil.filterObjects(searchedObjects, "_tmp");
        let obj_items = DataUtil.filterObjects(searchedObjects, "Items");
        let obj_checked = DataUtil.filterObjects(searchedObjects, "_checked");
        this.setState({ ...obj_tmp, ...obj_items, ...obj_checked, customDataObjects: { ...searchedObjects } }, () => {
            this.setState({
                originalObject: DataUtil.convertObjectToString(this.state.customDataObjects),
            });
        });
    }

    loadCurrentFlexSearchSave = () => {
        let lastsearchdata;
        let searchedObjects;
        try {
            lastsearchdata = JSON.parse(this.props.flexObjects.currentFlexSearchSave.searchData);
        } catch (e) { console.log("LOGS: loadFlexSeach Error", e) };
        if (lastsearchdata) {
            searchedObjects = { ...lastsearchdata };
            if (isPorscheArchiv()) {
                searchedObjects = fh.setUpFlexSearch({ searchedObjects, lastsearchdata, formConfig: this.props.formConfig });
            }
            this.props.expertSearchSaveData(searchedObjects);
            let obj_tmp = DataUtil.filterObjects(searchedObjects, "_tmp");
            let obj_items = DataUtil.filterObjects(searchedObjects, "Items");
            let obj_checked = DataUtil.filterObjects(searchedObjects, "_checked");
            this.setState({ ...obj_tmp, ...obj_items, ...obj_checked, customDataObjects: { ...searchedObjects } }, () => {
                this.setState({
                    originalObject: DataUtil.convertObjectToString(this.state.customDataObjects),
                });
            });
        }
    }

    setNewEntryInitalState = (msg) => {
        this.props.setCustomInitialState(null);
        this.props.setCustomUploadInfo({ "isLoading": false });
        DataUtil.showElementMsg(msg, this.state.pUploaded);
    }

    refreshCustomApiData = () => {
        let html = '';
        if (this.props.customNewEntry.data && this.props.customNewEntry.data.id) {
            let entryTxt = this.props.intl.formatMessage({ id: "customdata.entryMsg" });
            html = '<span> ' + entryTxt + ' ' + this.props.customNewEntry.data.id + ' </span>';
            SweetAlert.fire(DataUtil.getDialogMessageObj({ messageId: "createEntrySuccessMsg", formatMessage: this.props.intl.formatMessage, html }))
                .then(result => {
                    if (DataUtil.isNLW()) {
                        this.props.getCustomAppData(null, CustomTypes.API_PARENTSERIES);
                        this.props.getCustomAppData(null, CustomTypes.API_PROGRAMORSERIES);
                        this.props.loadSeriesTree();
                    }

                    this.setNewEntryInitalState(this.props.intl.formatMessage({ id: "customdata.entryCreatedMsg" }));
                    if (result.value) this.onCancel();
                });
        }
    }

    componentDidMount = () => {
        if (this.props.formDesign === CustomTypes.SEARCH_FORM) {
            this.setState({ left_count: CustomAppEventListener(CustomEvents.GET_FORM_COUNT, this.props.formConfig) });
            this.setupSearchObj();
        } else if (this.props.formDesign === CustomTypes.UPLOAD_FORM || this.props.formDesign === CustomTypes.MASTER_UPLOAD_FORM) {
            let res = window.flow.setInitialUploadState();
            this.props.uploadSetState();
            if (DataUtil.isPMDB() && this.props.formDesign === CustomTypes.UPLOAD_FORM) {
                this.setupUploadObj();
            } else {
                let shareUpCurrent = this.checkAndGetShareUploadObj();
                const { customDataObjects } = this.state;
                this.setState({
                    ...shareUpCurrent,
                    customDataObjects: { ...customDataObjects, ...shareUpCurrent }
                });
            }

            if (DataUtil.isNLW() && this.props.formDesign === CustomTypes.UPLOAD_FORM) {
                this.props.getCustomAppData(null, CustomTypes.API_PARENTSERIES);
                this.props.getCustomAppData(null, CustomTypes.API_PROGRAMORSERIES);
            }

            if (DataUtil.isFrancetv() && (this.props.formDesign === CustomTypes.UPLOAD_FORM || this.props.formDesign === CustomTypes.MASTER_UPLOAD_FORM)) {
                let appInitObj = CustomForm.initObjectsForApp("workflow", "uploadWorkflows", this.props.uiConfig, this.state.customDataObjects, this.props.lg);
                if (appInitObj) this.setState({ ...appInitObj });
            }
        }
        this.setState({ customdisplay_apptmp: "customdisplay", customdisplay_tmp: "customdisplayextends", appSubFormSectionShow: true });
    };

    checkLoadingData = ({ prevProps }) => {
        if (prevProps.rooms != this.props.rooms
            && Object.keys(this.props.rooms).length) {
            this.setState({ [`ddroomLoading`]: false });
        }
        if (prevProps.projectTree != this.props.projectTree
            && this.props.projectTree.length) {
            this.setState({ [`ddprojectLoading`]: false });
        }
        if (prevProps.eventrooms != this.props.eventrooms
            && this.props.eventrooms.length) {
            this.setState({ [`ddeventroomLoading`]: false });
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.formDesign === CustomTypes.UPLOAD_FORM) {
            try {
                if (prevProps.newData || this.props.newData) {
                    let ddname = this.props.customCurrentDialog;
                    if (!this.state.isDataUpdated || (this.props.newData.project.id !== prevProps.newData.project.id)) {
                        let { customDataObjects } = this.state;
                        let tmp = "";
                        if (ddname === "room") tmp = this.props.newData.project.title;
                        else tmp = this.props.newData.project.name;
                        if (tmp) {
                            this.setState({ [`${ddname}_tmp`]: tmp, isDataUpdated: true, customDataObjects: { ...customDataObjects, [ddname]: this.props.newData.project.id } });
                            let msg = DataUtil.writeName(`${ddname} ${tmp} created...`);
                            DataUtil.showElementMsg(msg, this.state.pUploaded, "#d5001c");
                            let currentTime = getLogDate();
                            this.props.setCustomUploadInfo({ "isLoading": false, [`${currentTime}`]: `New ${ddname} ${tmp} created` });
                        }
                    }
                }

                //this.showMinMaxForm(prevProps);
            } catch (error) {
                console.log("componentDidUpdate ERROR");
            }
        }

        if (CustomForm.isNewEntryForApp(this.state.customDataObjects.selectedObjects, this.props.formDesign)) {
            if (this.props.customNewEntry) {
                this.refreshCustomApiData();
            }
            if (this.props.customLoadError) this.setNewEntryInitalState("Something going wrong. Please try again...");
        }

        //MinMax BEGIN
        if (this.props.formDesign === CustomTypes.UPLOAD_FORM
            || this.props.formDesign === CustomTypes.MASTER_UPLOAD_FORM) {
            this.showMinMaxForm(prevProps);
        }
        //MinMax END

        if (isPorscheArchiv() && this.props.formDesign !== CustomTypes.ADD_FORM) {
            if (prevProps.flexTags != this.props.flexTags) {
                let name = CustomTypes.API_TAGS;
                let data = CustomAppEventListener(CustomEvents.SETUP_DROPDOWN, name, data, this.props);
                this.setState({ [`${name}CustomData`]: data, [`selected${name}s`]: data });
                if (!this.state[`${name}Items`]) this.setState({ [`${name}Items`]: [] });
            }

            if (prevProps.flexObjects.flexMulti != this.props.flexObjects.flexMulti) {
                if (!this.state.isCleared) {
                    console.log("LOGS: LAMTEST isCLEARED = FALSE!!");
                    let obj = fh.updateFlexSearchObj({ prevProps, props: this.props, state: this.state });
                    if (obj) this.setState(obj, () => {
                        this.setState({ originalObject: DataUtil.convertObjectToString(this.state.customDataObjects) });
                    });
                }
            }

            if (prevProps.flexObjects.currentFlexSearchSave != this.props.flexObjects.currentFlexSearchSave) {
                console.log("LOGS: loadCurrentFlexSearchSave");
                this.onClearAllData();
                this.loadCurrentFlexSearchSave();
            }
        }

        this.checkLoadingData({ prevProps });
    }

    componentWillUnmount() {
        if (this.nologoutinterval) clearInterval(this.nologoutinterval);
        if (this.props.customUploadInfo) this.props.setCustomUploadInfo({ "isLoading": false });
        if (isPorscheArchiv() && this.props.formDesign !== CustomTypes.ADD_FORM) {
            //if (this.props.flexTags) this.props.updateFlexObjects({ flexTags: null });
            if (this.props.flexObjects.currentFlexSearchSave) {
                this.props.updateFlexObjects({ currentFlexSearchSave: null });
            }
        }
    }

    //Submenu
    toggleSubmenu = (stateName,) => {
        if (this.state[stateName] === "none") this.setState({ [stateName]: "block" });
        else this.setState({ [stateName]: "none" });
    }
    onSubmenuIconClick = (name) => this.toggleSubmenu(`${name}SubmenuShow`);
    onSubFormIconClick = (name) => this.toggleSubmenu(`${name}SubFormShow`);

    //Disable Fields for Images and PDFs BEGIN
    toggleFields = ({ disabled }) => {
        if (isFrancetv() && this.props.formDesign === CustomTypes.UPLOAD_FORM) {
            const docItems = ["DataFlexBox", "DataListRow", "UpdatePicker"]
            docItems.forEach(item => {
                let elem = document.querySelectorAll(`[class*=CustomDataBox_${item}] input`);
                if (elem && elem.length) elem.forEach(el => el.disabled = disabled);
            })
            this.setState({ disableAll: disabled });
        }
    }

    isMatched = ({ files }) => {
        const { customDataObjects } = this.state;
        if (files && files.length) {
            let isSub = true;
            let checkType = files[0].type;
            if (customDataObjects.selectedObjects && customDataObjects.selectedObjects.length) {
                isSub = customDataObjects.selectedObjects.every(item => item.file.type.includes(checkType));
            }
            return files.every(item => item.type.includes(checkType)) && isSub;
        }
        return true;
    }

    allImgOrPDf = ({ files }) => {
        const { customDataObjects } = this.state;
        if (files && files.length) {
            let isSub = true;
            if (customDataObjects.selectedObjects && customDataObjects.selectedObjects.length) {
                isSub = customDataObjects.selectedObjects.every(item => item.file.type.includes(CustomTypes.IMG)
                    || item.file.type.includes(CustomTypes.PDF));
            }
            return files.every(item => item.type.includes(CustomTypes.IMG) || item.type.includes(CustomTypes.PDF)) && isSub;
        }
        return true;
    }

    checkFileForFields = (file) => {
        if (isFrancetv() && this.props.formDesign === CustomTypes.UPLOAD_FORM) {
            if (this.allImgOrPDf({ files: file })) {
                setTimeout(() => {
                    this.onClearAllData();
                    this.toggleFields({ disabled: true });
                }, 100);
                return true;
            }
            if (!this.isMatched({ files: file })) {
                let msg = this.props.intl.formatMessage({ id: "data.dontmatch" });
                DataUtil.showIntlConfirmDialogWithCallback(msg, this.props.intl.formatMessage, () => { });
                return false;
            }
        }
        return true;
    }
    //Disable Fields for Images and PDFs END

    addFile = file => {
        const { customDataObjects } = this.state;
        let updatedObjects = [];
        if (this.checkFileForFields(file) || !DataUtil.isFrancetv()) {
            updatedObjects = customDataObjects.selectedObjects;
            this.setState({
                files: file.map((file, i) => {
                    let index = this.state.fileId + i;
                    let url;
                    if (file.preview && file.preview !== "") url = file.preview;
                    else url = URL.createObjectURL(file);
                    updatedObjects.push({ fileId: index, name: file.name, url: url, file: file });
                    return Object.assign(file, {})
                })
            });
            this.setState({
                fileId: updatedObjects.length, customDataObjects: { ...customDataObjects, selectedObjects: updatedObjects }
            });
        }
    };

    //Select Files
    onChangeFile = event => {
        let selectedFiles = [];
        Object.keys(event.target.files).map((index) => {
            selectedFiles.push(event.target.files[index]);
        })
        this.addFile(selectedFiles);
        event.target.value = "";
    }

    dragMouseDown = e => {
        e = e || window.event;
        e.preventDefault();
        this.setState({ isPressed: true, pos3: e.clientX, pos4: e.clientY });
        document.onmouseup = this.closeDragElement;
        document.onmousemove = this.elementDrag;
    };

    elementDrag = e => {
        if (this.state.isPressed) {
            const { pos4, pos3, maxLeft, maxTop } = this.state;
            DataUtil.setElemPosition("CustomDataDivId", { pos4, pos3, maxLeft, maxTop }, e);
        }
    };

    closeDragElement = () => {
        this.setState({ isPressed: false });
        document.onmouseup = null;
        document.onmousemove = null;
    };

    pressEnterKey = e => {
        if (e.key === "Enter" && this.props.formDesign === CustomTypes.SEARCH_FORM) this.onExpertSearch();
    };

    handleKeyPress = () => {
        let element = document.getElementById("CustomDataDivId");
        if (element) element.onkeypress = this.pressEnterKey;
    }

    onDragStart = () => {
        let maxLeft = window.innerWidth - 400;
        let maxTop = window.innerHeight - 100;
        this.setState({ maxLeft: maxLeft, maxTop: maxTop });
        let elem = document.getElementById("CustomDataDivIdHeader");
        if (elem) {
            elem.onmousedown = this.dragMouseDown;
        }
    };

    updateUploadedObj = (name, value) => {
        const { customDataObjects } = this.state;
        this.setState({ customDataObjects: { ...customDataObjects, [name]: value } });
    };

    updateCustomObjects = (objects) => {
        const { customDataObjects } = this.state;
        this.setState({ ...objects, customDataObjects: { ...customDataObjects, ...objects } });
    };

    updateData = (event, dataName, checkedItems) => {
        const { customDataObjects } = this.state;
        let updatedObjects = this.getCheckedItems(event, this.state[checkedItems]);
        this.setState({
            [checkedItems]: updatedObjects,
            customDataObjects: { ...customDataObjects, [dataName]: updatedObjects.join(";") }
        });
    };

    updateSearchData = (e, name, data) => {
        let value = e.target.value;
        let lg = DataUtil.getLanguage(this.props.lg);
        value = value.trimStart();
        if (value) value = value.toLowerCase();
        let searchData = data.filter(item => {
            if (item.intl) {
                let msg = this.props.intl.formatMessage({ id: item.intl });
                if (msg && value) return msg.toLowerCase().includes(value);
            }
            if (item[lg] && value) return item[lg].toLowerCase().includes(value);
        });
        this.setState({ [name]: searchData });
    };

    onGetCheckedItem = event => {
        const { checked } = event.target;
        if (checked) this.updateUploadedObj("oneClip", true);
        else this.updateUploadedObj("oneClip", false);
        event.target.value = "";
    };

    onAdvCheck = (advName) => event => {
        const { checked } = event.target;
        if (checked) this.updateUploadedObj(advName, true);
        else this.updateUploadedObj(advName, false);

        event.target.value = "";
    }

    toggleRestrictionsHidden = (items) => {
        Object.keys(this.state).map((key) => {
            if (key.endsWith("SectionShow")) this.setState({ [key]: "block" });
        })
        if (DataUtil.isDataArray(items)) {
            items.map(item => {
                this.setState({ [`${item}SectionShow`]: "none", unlimitedMessageBox: "none" });
            })
            if (items.length === CustomConfig.customrights.data.length) this.setState({ unlimitedMessageBox: "block" });
        }
    }

    closeAllDropDowns = () => {
        Object.keys(this.state).map((key) => {
            if ((this.state[key] === "block") && (!key.includes("SubmenuShow")) && (!key.includes("SectionShow")) && (!key.includes("MessageBox"))) {
                this.setState({ [key]: "none" });
            }
            if ((this.state[key] === CustomAppEventListener(CustomEvents.GET_ICON, "arrowUpIcon")) && (!key.includes("SubmenuShow")) && (!key.includes("SectionShow"))) {
                this.setState({ [key]: CustomAppEventListener(CustomEvents.GET_ICON, "arrowDownIcon") });
            }
        })
    };

    toggleDropDowns = (stateName) => {
        this.closeAllDropDowns();
        if (this.state[stateName] === "none") {
            this.setState({ [stateName]: "block" });
        } else {
            this.setState({ [stateName]: "none" });
        }
    };

    openDropDowns = (stateName) => {
        if (this.state[stateName] === "none") {
            this.closeAllDropDowns();
            this.setState({ [stateName]: "block" });
        }
    };

    toggleSubmenu = (stateName) => {
        if (this.state[stateName] === "none") this.setState({ [stateName]: "block" });
        else this.setState({ [stateName]: "none" });
    }
    onSubmenuIconClick = (name) => this.toggleSubmenu(`${name}SubmenuShow`);

    getSelectedItems = (event, items, lg, ddname) => {
        let { name, value } = event.target;
        let updatedObjects = [...items];
        let found = false;
        updatedObjects.map(item => {
            if ((item.ID === parseInt(name)) || (item.ID === name)) found = true;
        })
        if (!found) {
            if (this.state[`selected${ddname}s`]) {
                this.state[`selected${ddname}s`].map(item => {
                    if (item.ID == name) {
                        updatedObjects.push(item);
                    }
                })
            } else {
                updatedObjects.push({ ID: name, [lg]: value });
            }
        }
        return updatedObjects;
    };

    setCustomFakeItem = (ddname) => {
        this.setState({
            [`${ddname}Items`]: [],
            [`${ddname}_apptmp`]: '',
            customDataObjects: { ...this.state.customDataObjects, [ddname]: null, [`${ddname}_ids`]: null }
        }, () => {
            this.toggleDropDowns(`${ddname}Show`);
        });
    }

    updateSelectedData = (event, ddname, isSingle) => {
        let isSearch = this.props.formDesign == CustomTypes.SEARCH_FORM;
        let isUpload = this.props.formDesign == CustomTypes.UPLOAD_FORM;
        try {
            if (event.target.name && event.target.name === "CustomFakeId") {
                this.setCustomFakeItem(ddname);
            }
            if (isSingle && this.state[`${ddname}Show`] && this.state[`${ddname}Items`].length >= 1) {
                this.toggleDropDowns(`${ddname}Show`);
            }
            else if (!(isSingle && this.state[`${ddname}Items`] && this.state[`${ddname}Items`].length >= 1)
                || fh.isFlexSearchMBoxDD({ ddname, isSearch }) || fh.isFlexUploadMBoxDD({ ddname, isUpload })) {
                const { customDataObjects } = this.state;
                let lg = DataUtil.getLanguage(this.props.lg);
                let updatedObjects = this.getSelectedItems(event, this.state[`${ddname}Items`], lg, ddname);
                let elementsIds = this.getDataString(updatedObjects, true);
                if (isPorscheArchiv() || isDZA()) {
                    if (this.props.formDesign === CustomTypes.UPLOAD_FORM) {
                        this.props.updateFlexObjects({ flexUpload: { ddname, ddvalue: elementsIds } });
                    } else {
                        this.props.updateFlexObjects({ flexMulti: { ddname, ddvalue: elementsIds } });
                    }
                }
                this.setState({
                    [`${ddname}Items`]: updatedObjects,
                    [`${ddname}_apptmp`]: elementsIds,
                    customDataObjects: { ...customDataObjects, [ddname]: elementsIds, [`${ddname}_ids`]: elementsIds }
                });
            }


        } catch (eror) {
            console.log("Data not found!!");
        }
    };

    getDataString = (data, isId) => {
        let dataArray = [];
        data.map(item => {
            (isId) ? dataArray.push(item.ID) : dataArray.push(item.DE);
        })
        return dataArray.join(";");
    }

    updateHistoryData = (action) => {
        let updatedHistory = DataUtil.updateHistoryData(this.props.user.id, action);
        let currentData;
        if (DataUtil.isFrancetv() || DataUtil.isPMDB()) currentData = DataUtil.refreshCurrentData(this.props.customHistory.showHistory, updatedHistory);
        if (updatedHistory) this.props.updateMetadata("clip", this.props.masterClipId, { history: updatedHistory });
        if (currentData) {
            this.props.setCustomHistory({ showHistory: { ...currentData } });
        }
    }

    setHistoryData = () => {
        if (this.props.customHistory.showHistory && (parseInt(this.props.masterClipId) === parseInt(this.props.customHistory.showHistory.clipid))) {
            const { customDataObjects } = this.state;
            if (customDataObjects && customDataObjects.useasthumbnail) {
                if (customDataObjects.selectedObjects && customDataObjects.selectedObjects.length) {
                    let len = customDataObjects.selectedObjects.length;
                    if (customDataObjects.selectedObjects[len - 1] && customDataObjects.selectedObjects[len - 1].file) {
                        if (customDataObjects.selectedObjects[len - 1].file.type.includes("image/")) this.updateHistoryData(CustomTypes.MASTER_THUMB_IMAGE);
                        else if (customDataObjects.selectedObjects[len - 1].file.type.includes("video/")) this.updateHistoryData(CustomTypes.MASTER_THUMB_VIDEO);
                    }
                }
            }
            this.updateHistoryData(CustomTypes.MASTER_UPLOAD);
        }
    }

    updateShareUpload = () => {
        const { shareUpload } = this.props.shareObjects;
        if (shareUpload.current && shareUpload.shouldReload) {
            setTimeout(() => this.props.updateMetadata(shareUpload.type, shareUpload.current[shareUpload.type], {}), 1000);
            this.props.updateShareObjects({
                shareUpload: { ...shareUpload, clicked: false, shouldReload: false }
            });
        }
    }

    closeAllUploadWindows = () => {
        if (!this.state.allClosed) {
            if (this.props.formDesign == CustomTypes.MASTER_UPLOAD_FORM) {
                if (!this.state.isMetadataUpdated && !this.state.aborted && this.state.masterUploading) {
                    this.props.updateMetadata("clip", this.props.masterClipId, {});
                    this.setState({ isMetadataUpdated: true, masterUploading: true });
                    if (DataUtil.isFrancetv() || DataUtil.isPMDB()) {
                        this.setHistoryData();
                    }
                }
                this.props.setupCustomForm({ formState: 'closed' });
            }

            //Project/Room Upload
            this.updateShareUpload();

            if (this.props.uploadState && this.props.uploadState === "uploaded") {
                if (DataUtil.isNLW() && this.props.formDesign === CustomTypes.UPLOAD_FORM) this.props.loadSeriesTree();
            }
            this.props.uploadSetState();
            this.props.setNewData(null);
            this.setState({ allClosed: true });
            //MinMax
            if (this.props.formDesign === CustomTypes.UPLOAD_FORM) {
                this.props.closed();
            }

        }
    };

    setEmptyUiState = () => {
        let selectedTags = [];
        let selectedModels = [];
        this.props.saveSelectedTags(selectedTags);
        this.props.saveSelectedModels(selectedModels);
    };

    onHandleChange = event => {
        const { name, value } = event.target;
        const { customDataObjects } = this.state;
        this.setState({ customDataObjects: { ...customDataObjects, [name]: value } });
    };

    onKeyPress = (event) => {
        const { type } = event.target;
        if (type == 'number') {
            if (event.key == '+' || event.key == '-') {
                event.preventDefault();
            }
        }
    }

    onAddHandleChange = (name, event) => {
        const { value } = event.target;
        const { customDataObjects } = this.state;
        this.setState({ customDataObjects: { ...customDataObjects, [name]: value } });
    };

    onTextAreaHandleChange = (event) => {
        const { name, value } = event.target;
        const { customDataObjects } = this.state;
        let tmpRows = name + 'rows';
        let currentRows = DataUtil.resizeTextArea(event);
        this.setState({ [tmpRows]: currentRows, customDataObjects: { ...customDataObjects, [name]: value } });
    }

    onCheckBoxChange = event => {
        const { checked, name } = event.target;
        const { customDataObjects } = this.state;
        let updatedObj = customDataObjects[name];
        if (checked) {
            if (name === CustomTypes.ANIMATION_CGI) updatedObj = "cgi";
            else updatedObj = 1;
            this.setState({ [name]: true, [`${name}_checked`]: true });
        } else {
            updatedObj = "no";
            this.setState({ [name]: false, [`${name}_checked`]: false })
        }
        this.setState({
            customDataObjects: { ...customDataObjects, [name]: updatedObj }
        });
    };

    onDropDownAndCheckBoxChange = (name, checkboxData, event) => {
        const { checked } = event.target;
        const { customDataObjects } = this.state;
        if ((this.state[`${name}_tmp`] || customDataObjects[`${name}_tmp`]) && checked) {
            this.setState({
                [`${name}_tmp`]: "", [name]: true, [`${name}_checked`]: true,
                customDataObjects: { ...customDataObjects, [name]: checkboxData, [`${name}_tmp`]: "" }
            });
        }
        else {
            this.setState({
                [name]: checked, [`${name}_checked`]: checked,
                customDataObjects: { ...customDataObjects, [name]: checked ? checkboxData : "" }
            });
        }
    }

    getSelectedData = (name, value) => {
        let selectedData = [];
        let lg = DataUtil.getLanguage(this.props.lg);
        if (value && this.state[name]) {
            value = value.trimStart();
            selectedData = this.state[name].filter(item => {
                if (item.intl) {
                    let msg = this.props.intl.formatMessage({ id: item.intl });
                    if (msg && value) return msg.toLowerCase().includes(value.toLowerCase());
                }
                if (item[lg] && value) return item[lg].toLowerCase().includes(value.toLowerCase());

                /*
                if (item.intl) return this.props.intl.formatMessage({ id: item.intl })
                    .toLowerCase().includes(value.toLowerCase())
                return item[lg].toLowerCase().includes(value.toLowerCase())
                */
            });
        } else selectedData = this.state[name];
        return selectedData;
    };

    stopUpload = () => {
        if (this.state.uploadStatus === 'uploading') {
            this.updateUploadedObj("selectedObjects", []);
            this.setState({ uploadStatus: "none", fileId: 0 });
            this.props.uploadSetState();
            if (this.props.customUploadInfo) this.props.setCustomUploadInfo({ "isLoading": false });
            DataUtil.showElementMsg("Upload cancelled...", this.state.pUploaded, "white");

            if (this.state.shouldClose) {
                setTimeout(() => { this.closeAllUploadWindows(); }
                    , 1000);
            } else if (this.state.formCancelling) this.setState({ formCancelling: false });

        }
    }

    checkAndCloseUploadFormForApp = () => {
        if (DataUtil.isPMDB() || !this.state.appFormCloseMsg)
            this.closeAllUploadWindows();
    }

    uploadMoreClick = () => {
        this.updateUploadedObj("selectedObjects", []);
        this.setState({ uploadStatus: "none", fileId: 0 });
        this.props.uploadSetState();
        if (this.props.customUploadInfo) this.props.setCustomUploadInfo({ "isLoading": false });
        if (DataUtil.isFrancetv() && this.state.disableAll) {
            this.toggleFields({ disabled: false });
        }
    }

    showUploadSuccessDlg = () => {
        if (!this.state.uploadMore) {
            let msg = this.props.intl.formatMessage({ id: "customdata.uploadsuccess" });
            if (DataUtil.isPMDB() && this.props.formDesign == CustomTypes.MASTER_UPLOAD_FORM) {
                msg = this.props.intl.formatMessage({ id: "customdata.uploadsuccess.master" });
            }
            let uploadMoreBtn = this.props.intl.formatMessage({ id: "customdata.uploadmore" });
            let uploadOKBtn = this.props.intl.formatMessage({ id: "customdata.uploadok" });
            this.setState({ uploadMore: true }, () => {
                DataUtil.showAutoCloseDlg(`<p>${msg}</p>`, uploadOKBtn, () => this.checkAndCloseUploadFormForApp(),
                    uploadMoreBtn, () => this.uploadMoreClick());
            });
        }
    }

    startProgressBar = () => {
        let timerId;
        try {
            let width = 1;
            timerId = setInterval(() => {
                if (this.props.uploadState !== "uploading") {
                    if (this.props.uploadState === "uploadImportFileError") {
                        DataUtil.showStatusMessage(this.props.pcObj, timerId, this.closeAllUploadWindows, this.state.pUploaded);
                    } else {
                        if (this.props.uploadState === "uploaded") {
                            if (typeof this.props.pcObj.fileId) {
                                width = 100;
                                DataUtil.showElements(this.props.pcObj.id, width, this.props.intl.formatMessage({ id: "customdata.filesUploadedMsg" }), this.state.pUploaded);
                                this.props.setCustomUploadInfo({ "isLoading": false });
                                this.setState({ uploadStatus: "none" });
                            }
                        } else {
                            if (this.state.aborted) {
                                DataUtil.showElementMsg(this.props.intl.formatMessage({ id: "customdata.uploadCancelledMsg" }), this.state.pUploaded, CustomTypes.COLOR_RED);
                            }
                        }
                        delay(CustomTypes.AUTO_CLOSE_TIME).then(() => {
                            clearInterval(timerId);
                            if (this.state.aborted) {
                                this.stopUpload();
                            }
                            else {
                                //MinMax BEGIN
                                this.checkMinMaxForm();
                                //MinMax END
                                this.showUploadSuccessDlg();
                            }
                        });
                    }
                } else {
                    DataUtil.showProgressBar(this.props.pcObj, width, this.props.intl.formatMessage, this.state.pUploaded);

                }
            }, 100);
        } catch (error) {
            clearInterval(timerId);
            console.log("ERROR startProgressBar");
            this.closeAllUploadWindows();
        }
    };

    onTimeChange = (name, event) => {
        const { value } = event.target;
        this.setState({ [name]: value });
        this.updateUploadedObj(`${name}`, value);
    };

    getCheckedItems = (event, items) => {
        const { name, checked } = event.target;
        let updatedObjects = items || [];
        if (checked) {
            updatedObjects.push(name);
        } else {
            updatedObjects = items.filter(item => item !== name);
        }
        return updatedObjects;
    };

    onCheckBoxListChange = (name, event) => {
        try {
            const { customDataObjects } = this.state;
            let updatedObjects = this.getCheckedItems(event, this.state[`${name}Items`]);
            let tmp = updatedObjects.join(";");
            if ((name === CustomTypes.RIGHTS_FIELD) && DataUtil.isPMDB()) {
                this.toggleRestrictionsHidden(updatedObjects);
                let rightObjects = DataUtil.initRightsObjects({
                    rightsData: updatedObjects, objects: this.state.customDataObjects,
                    formConfig: this.props.formConfig
                });
                this.setState({
                    ...rightObjects,
                    [`${name}Items`]: updatedObjects,
                    [name]: tmp,
                    customDataObjects: { ...rightObjects, [`${name}Items`]: updatedObjects, [name]: tmp }
                });

            } else {
                this.setState({
                    [`${name}Items`]: updatedObjects,
                    [name]: tmp,
                    customDataObjects: { ...customDataObjects, [`${name}Items`]: updatedObjects, [name]: tmp }
                });
            }
        } catch (error) {
            console.log("ERROR: Data not found!");
        }
    };

    dropdownChange = (name, customdata, event, isAddBtn = false) => {
        if (DataUtil.isPorscheArchiv() && name === fTypes.ARCHIV_FIELD) {
            this.setState({ [`${name}_tmp`]: '' });
            return;
        }
        try {
            if (CustomAppEventListener(CustomEvents.CHECK_GRANTING, name, this.props.user.role)) {
                const { value } = event.target;
                let data = customdata;
                if (this.state[`${name}_checked`]) this.setState({ [`${name}_checked`]: false });
                if (!this.state[`${name}Show`]) {
                    this.closeAllDropDowns();
                    this.setState({ [`${name}Show`]: "block" });
                }
                if (!this.state[`${name}CustomData`] || !this.state[`${name}CustomData`].length
                    || (this.props.newData && this.props.newData[name])) {
                    data = CustomAppEventListener(CustomEvents.SETUP_DROPDOWN, name, data, this.props);
                    if (!this.state[`${name}Items`]) this.setState({ [`${name}Items`]: [] });
                    if ((!data || !data.length) && customdata && customdata.length) data = customdata;
                    this.setState({ [`${name}CustomData`]: data, [`selected${name}s`]: data });
                    this.updateSearchData(event, `selected${name}s`, data);
                }
                else this.updateSearchData(event, `selected${name}s`, this.state[`${name}CustomData`]);

                let selecteddata = this.getSelectedData(`${name}CustomData`, value);
                this.setState({ [`selected${name}s`]: selecteddata, [`${name}_tmp`]: value }, () => {
                    if (!this.state[`selected${name}s`]) {
                        this.setState({ [`selected${name}s`]: this.state[`${name}CustomData`] });
                    }
                });

                if (this.props.formDesign === CustomTypes.SEARCH_FORM || isAddBtn) {
                    this.updateUploadedObj(`${name}`, value);
                }
                this.openDropDowns(`${name}Show`);
                if (CustomForm.shouldRefreshDataForApp(name, this.props.formDesign)) {
                    if (value && value.lenght >= CustomTypes.SEARCH_LEN) {
                        this.props.getCustomAppData(value, name);
                        setTimeout(() => {
                            data = CustomAppEventListener(CustomEvents.SETUP_DROPDOWN, name, data, this.props);
                            this.setState({ [`${name}CustomData`]: data, [`selected${name}s`]: data });
                        }, 500);
                    }
                }
            }
        } catch (eror) {
            console.log(eror);
            console.log("Data not found!");
        }
    };


    onDropDownDataHandleClick = (ddname, event) => {
        if (CustomAppEventListener(CustomEvents.CHECK_GRANTING, ddname, this.props.user.role)) {
            if (this.state[`${ddname}_checked`]) this.setState({ [`${ddname}_checked`]: false });
            const { name, value } = event.target;
            this.setState({ [`${ddname}_tmp`]: value, [`${ddname}_apptmp`]: name });
            if (isNLW() && ddname == CustomTypes.API_PROGRAMORSERIES && this.props.formDesign === CustomTypes.UPLOAD_FORM) {
                if (value.includes(CustomTypes.GUI_SERIES_PROGRAM))
                    this.props.getCustomAppData(name, CustomTypes.API_SERIES_PARENT);
            }
            this.updateUploadedObj(`${ddname}`, name);
            this.toggleDropDowns(`${ddname}Show`);
        }
    };

    onDropDownDataChange = (name, customdata, event) => this.dropdownChange(name, customdata, event);

    onDropDownAddBtnDataChange = (name, customdata, event) => this.dropdownChange(name, customdata, event, true);

    onDropDownIconClick = (name, data) => {
        if (!this.state.disableAll) {
            this.closeAllDropDowns();
            if (!this.state[`${name}Show`]) this.setState({ [`${name}Show`]: "block" });
            else this.toggleDropDowns(`${name}Show`);
            if ((!this.state[`${name}CustomData`] || !this.state[`${name}CustomData`].length
                || !DataUtil.isDataArray(this.state[`${name}CustomData`]) || (this.props.newData && this.props.newData[name])
                || CustomForm.refreshApiContentForApp(name, this.props))) {
                data = CustomAppEventListener(CustomEvents.SETUP_DROPDOWN, name, data, this.props);
                if (!data || !data.length) {
                    this.toggleDropDowns(`${name}Show`);
                    this.setState({ [`dd${name}Loading`]: true });
                    //setTimeout(() => this.setState({ [`dd${name}Loading`]: false }), 1000);
                }
                this.setState({ [`${name}CustomData`]: data, [`selected${name}s`]: data });
                if (!this.state[`${name}Items`]) this.setState({ [`${name}Items`]: [] });
            }
        }
    }

    onFadeBoxDropDownDataHandleClick = (ddname, isSingle, event) => this.updateSelectedData(event, `${ddname}`, isSingle);
    onFadeBoxDropDownDataChange = (name, customdata, event) => this.dropdownChange(name, customdata, event);

    removeFields = (ddname) => {
        const { customDataObjects } = this.state;
        this.setState({
            [`${ddname}_tmp`]: '',
            [`${ddname}_apptmp`]: '',
            [`${ddname}`]: '',
            [`${ddname}Items`]: '',
            customDataObjects: {
                ...customDataObjects,
                [`${ddname}`]: '', [`${ddname}_ids`]: '', [`${ddname}Items`]: ''
            }
        });
    }

    onFadeBoxDropDownRemoveItems = (ddname, id) => {
        const { customDataObjects } = this.state;
        let lg = DataUtil.getLanguage(this.props.lg);
        let updatedObjects = this.state[`${ddname}Items`].filter(item => item.ID !== id);
        let elements = this.getDataString(updatedObjects, false, lg);
        let elementsIds = this.getDataString(updatedObjects, true, lg);
        if (isPorscheArchiv() || isDZA()) {
            if (this.props.formDesign === CustomTypes.UPLOAD_FORM) {
                if (ddname === CustomTypes.MBOX) this.removeFields(fTypes.ARCHIV_FIELD);
                this.props.updateFlexObjects({ flexUpload: { ddname, ddvalue: elementsIds } });
            } else {
                this.props.updateFlexObjects({ flexMulti: { ddname, ddvalue: elementsIds } });
            }
        }

        this.setState({
            [`${ddname}Items`]: updatedObjects,
            [`${ddname}_apptmp`]: elementsIds,
            customDataObjects: { ...customDataObjects, [`${ddname}`]: elements, [`${ddname}_ids`]: elementsIds }
        });

        if ((this.state[`${ddname}Items`] && this.state[`${ddname}Items`].length === 1)) {
            this.removeFields(ddname);
        }
    }

    onDDIconDelete = (item) => () => {
        if (isPorscheArchiv()) {
            if (item.name && item.name == CustomTypes.STOCK) {
                this.setState({
                    [`${item.name}_ids`]: "", [`${item.name}`]: "",
                    customDataObjects: {
                        ...this.state.customDataObjects,
                        [`${item.name}_ids`]: "", [`${item.name}`]: ""
                    }
                });
            }
        }
        this.setState({ [`${item.name}_tmp`]: "" });
        this.setState({ [`selected${item.name}s`]: this.state[`${item.name}CustomData`] });
    }

    onDateChange = (name, date) => {
        try {
            if (!this.state.disableAll) {
                const { customDataObjects } = this.state;
                let localDate = DataUtil.changeTime(date);
                this.setState({ [name]: localDate, customDataObjects: { ...customDataObjects, [name]: localDate } });
            }
        } catch (error) {
            console.log("ERROR: onDateChange!");
        }
    };

    onDateTimeChange = (name, date) => {
        try {
            const { customDataObjects } = this.state;
            this.setState({ [name]: date, customDataObjects: { ...customDataObjects, [name]: date } });
        } catch (error) {
            console.log("ERROR: onDateChange!");
        }
    };

    onFlexDate = ({ name, date, hasErrors = false }) => {
        try {
            if (hasErrors) {
                this.setState({
                    hasErrObjects: {
                        ...this.state.hasErrObjects, [`${name}_isRequired`]: true
                    }
                });
            } else {
                const { customDataObjects } = this.state;
                let json = JSON.stringify(date);
                this.setState({
                    [name]: json,
                    hasErrObjects: { ...this.state.hasErrObjects, [`${name}_isRequired`]: false },
                    customDataObjects: { ...customDataObjects, [name]: json }
                });
                console.log("LOGS: onFlexDate updated! json", json);
            }

        } catch (error) {
            console.log("ERROR: onDateChange!");
        }
    };

    startUploadAndSaveData = (startUpload) => {
        const { customDataObjects } = this.state;
        let uploadedObjects = { ...customDataObjects };

        this.setEmptyUiState();
        let obj_tmp = DataUtil.filterObjects(this.state, "_tmp");
        let obj_items = DataUtil.filterObjects(this.state, "Items");
        let obj_checked = DataUtil.filterObjects(this.state, "_checked");

        if (this.props.formDesign == CustomTypes.MASTER_UPLOAD_FORM) {
            this.setState({ masterUploading: true });
            uploadedObjects = { ...uploadedObjects, appId: CustomTypes.MASTER_UPLOAD_FORM, masterClipId: this.props.masterClipId };
        } else {
            let lastUpload = { ...uploadedObjects, ...obj_tmp, ...obj_items, ...obj_checked };

            this.props.uploadSaveUploadedData(lastUpload);
            this.props.saveLastCustomData({ id: this.props.user.id, groupid: this.props.user.groupid }, "lastuploaddata", lastUpload);
        }

        if (startUpload) {
            DataUtil.setDefaultValueForList(uploadedObjects.selectedObjects);
            let user = CustomAppEventListener("getUserData", this.props.user);
            if (DataUtil.isSdk() && this.props.user && this.props.user.permission
                && this.props.user.permission.postuploadfunction) {
                user = { ...user, isPostUp: true };
            }
            if (DataUtil.isPMDB()) {
                this.props.uploadFile({ ...uploadedObjects, user });
            } else {
                let withConditionObj = DataUtil.doValidationForApp(this.props.formConfig, uploadedObjects, this.state);
                withConditionObj = CustomForm.changeConfigToMWFieldsForApp(withConditionObj, this.props.uiConfig, this.props.formDesign);
                //console.log("LAMTEST withConditionObj", withConditionObj);
                if (DataUtil.isVifogra()) {
                    if (withConditionObj && !withConditionObj.distribution && this.props.articleObjects.currentDisplay) {
                        withConditionObj = { ...withConditionObj, distribution: this.props.articleObjects.currentDisplay };
                    }
                }
                if (CustomForm.isNewEntryForApp(this.state.customDataObjects.selectedObjects, this.props.formDesign)) {
                    SweetAlert.fire(DataUtil.getDialogMessageObj({ messageId: "createEntryMsg", formatMessage: this.props.intl.formatMessage }, "createMsg"))
                        .then(result => {
                            if (result.value) {
                                this.props.setCustomUploadInfo({ "isLoading": true });
                                DataUtil.showElementMsg(this.props.intl.formatMessage({ id: "customdata.entryCreatingMsg" }), this.state.pUploaded);
                                setTimeout(() => {
                                    this.props.createNewEntry({ ...withConditionObj, user });
                                }, 2000);

                            }
                        });
                }
                else this.props.uploadFile({ ...withConditionObj, user });
            }
            try {
                this.nologoutinterval = setInterval(window.flow.nologout.bind(window.flow), 240000);
            } catch (err) {
                console.log("LAMTEST window.flow.nologout ERROR");
            }
            if (!CustomForm.isNewEntryForApp(this.state.customDataObjects.selectedObjects, this.props.formDesign)) {
                DataUtil.showElementMsg(this.props.intl.formatMessage({ id: "customdata.uploadingMsg" }), this.state.pUploaded);
                this.props.setCustomUploadInfo({ "isLoading": true });
                this.startProgressBar();
                this.setState({ uploadStatus: "uploading", btnBgColor: '#b61924', btnColor: 'white' });
            }
        }
    };

    startUpload = () => this.startUploadAndSaveData(true);

    checkUploadObjects = () => {
        if (
            (Array.isArray(this.state.customDataObjects.selectedObjects) &&
                this.state.customDataObjects.selectedObjects.length > 0)
            || ((isNLW() || isFrancetv() || isPorscheArchiv()) && this.props.formDesign !== CustomTypes.MASTER_UPLOAD_FORM)
        ) {
            if (DataUtil.isFrancetv() && this.state.disableAll && this.props.formDesign === CustomTypes.UPLOAD_FORM) {
                this.startUpload();
                return;
            }
            if (DataUtil.isPMDB() && this.props.formDesign !== CustomTypes.MASTER_UPLOAD_FORM) {
                let uploadBasicData = this.props.formConfig[0].data.filter(entry => entry.upload && entry.upload.required);
                let isValid = DataUtil.checkBasicFields(uploadBasicData, this.state.customDataObjects, this.props.user.role);
                let requiredObjects = DataUtil.showRequiredFields(uploadBasicData, this.state.customDataObjects, this.props.user.role);
                this.setState({ ...requiredObjects });
                let isVrightsValid = DataUtil.checkRightsObjects({ rightsObj: this.state.customDataObjects, formConfig: this.props.formConfig });
                if (isValid && isVrightsValid) {
                    this.startUpload();
                } else {
                    if (!isValid) {
                        DataUtil.showIntlMsg(this.props.intl.formatMessage({ id: `customdata.fillInMsg` }));
                    } else {
                        if (!isVrightsValid) {
                            DataUtil.showIntlMsg(this.props.intl.formatMessage({ id: `customdata.rightsMsg` }));
                        } else {
                            this.startUpload();
                        }
                    }
                }
            } else {
                let requiredObjects = DataUtil.displayRequiredFields(this.props.formConfig, this.state.customDataObjects);
                if (this.state.hasErrObjects && Object.keys(this.state.hasErrObjects).length > 0) {
                    requiredObjects = { ...requiredObjects, ...this.state.hasErrObjects };
                }
                this.setState({ ...requiredObjects });
                let isValid = DataUtil.validateFieldsForApp(requiredObjects);
                if (!isValid) DataUtil.showIntlMsg(this.props.intl.formatMessage({ id: `customdata.fillInMsg` }));
                else this.startUpload();
            }
        } else {
            DataUtil.showIntlMsg(this.props.intl.formatMessage({ id: `customdata.selectFilesMsg` }));
        }
    }

    onUploadFile = () => {
        this.setState({ uploadMore: false });
        const reload = () => {
            this.setState({ aborted: false });
            this.checkUploadObjects();
        }
        if (this.state.uploadStatus !== "uploading" && !this.state.appFormCloseMsg) {
            if (this.state.aborted) {
                let setUploadInitialState = async function () {
                    let res = await window.flow.setInitialUploadState();
                    if (!res.aborted) {
                        reload();
                    }
                }
                setUploadInitialState();
            } else {
                this.checkUploadObjects();
            }
        }
    };

    onClearAllData = () => {
        const { selectedObjects } = this.state.customDataObjects;
        if (this.state.uploadStatus !== "uploading") {
            Object.keys(this.state).map((key) => {
                if ((key.includes("Items"))) this.setState({ [key]: [] });
                if (key.endsWith("_checked")) this.setState({ [key]: false });
                if (key.endsWith("_tmp") || key.endsWith("_apptmp") || (key.endsWith("Date"))) this.setState({ [key]: "" });
                if (key.endsWith("resSectionShow")) this.setState({ [key]: "block" });
                if (key.endsWith("_isRequired")) this.setState({ [key]: null });
            })
            this.setState({
                isDeleted: true,
                customdisplay_apptmp: "customdisplay",
                customdisplay_tmp: "customdisplayextends",
                appSubFormSectionShow: true,
                unlimitedMessageBox: "none",
                customDataObjects: {
                    selectedObjects: selectedObjects,
                    oneClip: false,
                }
            },
                () => {
                    this.setState({ isDeleted: false });
                    // if (DataUtil.isPMDB() && this.props.formDesign === CustomTypes.SEARCH_FORM) {
                    if (this.props.formDesign === CustomTypes.SEARCH_FORM) {
                        this.props.expertSearchSaveData({});
                        this.props.saveLastCustomData({ id: this.props.user.id, groupid: this.props.user.groupid }, "lastsearchdata", {});
                        if ((isPorscheArchiv() || isDZA())) {
                            this.props.updateFlexObjects({ flexMulti: { ddname: CustomTypes.MBOX, ddvalue: '' } });
                            this.setState({ isCleared: true }, () => setTimeout(() => this.setState({ isCleared: false }), 2000));
                        }
                    }
                    if ((DataUtil.isPMDB()) && this.props.formDesign === CustomTypes.UPLOAD_FORM) {
                        this.props.uploadSaveUploadedData({});
                        this.props.saveLastCustomData({ id: this.props.user.id, groupid: this.props.user.groupid }, "lastuploaddata", {});
                        let grantingObjects = this.setGrantingObj();
                        if (grantingObjects) this.updateCustomObjects(grantingObjects);
                        this.toggleRestrictionsHidden(this.state[`${CustomConfig.customrights.name}Items`]);
                    }
                    if ((isPorscheArchiv() || isDZA()) && this.props.formDesign === CustomTypes.UPLOAD_FORM) {
                        this.props.updateFlexObjects({ flexUpload: { ddname: CustomTypes.MBOX, ddvalue: '' } });
                    }
                }
            );
        }
    }

    onClearFiles = () => {
        if (
            Array.isArray(this.state.customDataObjects.selectedObjects) &&
            this.state.customDataObjects.selectedObjects.length > 0 && this.state.uploadStatus !== "uploading"
        ) {
            this.updateUploadedObj("selectedObjects", []);
            this.setState({ uploadStatus: "none", fileId: 0 });
        }
        if (DataUtil.isFrancetv() && this.state.disableAll) {
            this.toggleFields({ disabled: false });
        }
    }

    checkAndSetListBoxDefault = () => {
        if (this.props.customFlexAppConfig.listBoxPublished) {
            this.props.getCustomFlexAppConfig({ listBoxPublished: false });
        }
        if (this.props.customFlexAppConfig.listBoxSorted) {
            this.props.getCustomFlexAppConfig({ listBoxSorted: false });
        }
    }

    onFlexSearchSaveList = () => {
        const { customDataObjects } = this.state;
        const stock = customDataObjects.stock || "";
        let content = customDataObjects.content || '';
        const updatedSearchObjects = CustomAppEventListener(CustomEvents.UPDATE_SEARCH_OBJ, customDataObjects, this.state, this.props.lg);
        let obj_tmp = DataUtil.filterObjects(this.state, "_tmp");
        let obj_items = DataUtil.filterObjects(this.state, "Items");
        let obj_checked = DataUtil.filterObjects(this.state, "_checked");
        let lastSearch = { ...updatedSearchObjects, ...obj_tmp, ...obj_items, ...obj_checked };
        if (stock) lastSearch.stock = stock;
        if (content) {
            lastSearch.content = content;
        }
        return JSON.stringify(lastSearch);
    }

    onExpertSearch = () => {
        const { customDataObjects } = this.state;
        const stock = customDataObjects.stock || "";
        let content = customDataObjects.content || '';
        if (this.state.content_apptmp) content = this.state.content_apptmp;
        if (this.state.content) content = this.state.content;
        const updatedSearchObjects = CustomAppEventListener(CustomEvents.UPDATE_SEARCH_OBJ, customDataObjects, this.state, this.props.lg);
        let obj_tmp = DataUtil.filterObjects(this.state, "_tmp");
        let obj_items = DataUtil.filterObjects(this.state, "Items");
        let obj_checked = DataUtil.filterObjects(this.state, "_checked");
        //ListBox: sorting and published
        this.checkAndSetListBoxDefault();

        if (this.props.customCurrentSortOption === CustomTypes.SORTING) {
            this.props.setCustomCurrentSortOption(CustomTypes.SORT_DEFAULT);
        }
        this.props.expertSearchSetupData({});
        let lastSearch = { ...updatedSearchObjects, ...obj_tmp, ...obj_items, ...obj_checked };
        if (isPorscheArchiv()) {
            if (stock) lastSearch.stock = stock;
            if (content) {
                lastSearch.content = content;
                updatedSearchObjects.content = content;
            }
        }
        this.props.expertSearchSaveData(lastSearch);
        this.props.saveLastCustomData({ id: this.props.user.id, groupid: this.props.user.groupid }, "lastsearchdata", lastSearch);
        let changedSearchObjects = CustomAppEventListener(CustomEvents.CHANGE_SEARCH_OBJ, updatedSearchObjects, "id", "mediafile.id", "mf");
        if (changedSearchObjects && typeof changedSearchObjects.uploader == 'undefined') delete changedSearchObjects.uploader;
        this.props.searchClosed();
        //disable Clip Metadata View
        this.props.setCurrentClip();

        //this.props.history.push({ pathname: '/search', searchParams: { ...changedSearchObjects, customCurrentSortOption: this.props.customCurrentSortOption } });
        let searchParams = { ...changedSearchObjects, customCurrentSortOption: this.props.customCurrentSortOption };
        this.props.history.push({ pathname: '/search', searchParams: searchParams, state: { search: JSON.stringify(searchParams) } });
    }

    onDropDownAddClick = (ddname) => {
        if (!this.state.disableAll) {
            this.props.setCurrentDialog(ddname);
            this.setState({ isDataUpdated: false }, () => {
                this.props.setAddFormState("open");
            });
        }
    }

    onDiscardChanges = () => {
        if (isPorscheArchiv()) {
            if (this.props.flexObjects.currentFlexSearchSave) {
                this.props.updateFlexObjects({ resetCurrentFlexSearch: true });
            }
        }
        this.onClearAllData();
    }

    closeExpertSearch = () => {
        const { customDataObjects, originalObject } = this.state;
        let isChanged = DataUtil.isChangedObject(originalObject, customDataObjects);
        if (DataUtil.isPMDB() && isChanged && !DataUtil.isObjectsEmpty(customDataObjects)) {
            // SweetAlert.fire(DataUtil.getDialogMessageObj({ messageId: "CustomMsgCloseSearchDialog", language: this.props.lg }))
            SweetAlert.fire(DataUtil.getDialogMessageObj({ messageId: "closeSearchMsg", formatMessage: this.props.intl.formatMessage }))
                .then(result => {
                    if (result.value) this.props.searchClosed();
                    else this.setState({ formCancelling: false });
                });
        } else this.props.searchClosed();
    }

    setUploadCancelState = () => {
        this.props.uploadCancel();
        this.setState({ aborted: true });
    }

    closeSearchForm = () => {
        if (DataUtil.isPMDB()) this.closeExpertSearch();
        else this.props.searchClosed();
    }

    closeUploadFormForApp = () => {
        if (DataUtil.isPMDB()) {
            this.setUploadCancelState();
        } else {
            if (this.state.uploadIconClicked) {
                this.setState({ appFormCloseMsg: true }, () => {
                    SweetAlert.fire(DataUtil.getDialogMessageObj({ messageId: "closeUploadMsg", formatMessage: this.props.intl.formatMessage }))
                        .then(result => {
                            if (result.value) {
                                if (this.state.uploadStatus === "uploading")
                                    this.setState({ appFormCloseMsg: false }, () => this.setUploadCancelState());
                                else
                                    this.setState({ appFormCloseMsg: false }, () => this.shouldCloseForm());
                            } else this.waitAndCloseForm();
                        });
                })
            } else this.setUploadCancelState();
        }
    }

    waitAndCloseForm = () => {
        setTimeout(() => {
            this.setState({ appFormCloseMsg: false, formCancelling: false }, () => {
                this.shouldCloseForm();
            });
        }, 3000);
    }

    shouldCloseForm = () => {
        if (!this.state.allClosed && this.state.uploadStatus !== "uploading") {
            this.closeAllUploadWindows();
        }
    }

    startCloseUploadForm = () => {
        const { customDataObjects, originalObject } = this.state;
        this.setEmptyUiState();
        if (this.state.uploadStatus !== "uploading") {
            let isChanged = DataUtil.isChangedObject(originalObject, customDataObjects);
            if (DataUtil.isPMDB() && isChanged && !DataUtil.isObjectsEmpty(customDataObjects) && this.props.formDesign === CustomTypes.UPLOAD_FORM) {
                SweetAlert.fire(DataUtil.getDialogMessageObj({ messageId: "saveDataMsg", formatMessage: this.props.intl.formatMessage, confirmButtonText: "saveMsg" }))
                    .then(result => {
                        if (result.value) {
                            this.startUploadAndSaveData(false);
                        } else {
                            let original = DataUtil.convertStringToObject(originalObject);
                            if (original) {
                                original = { ...original, selectedObjects: this.state.originalselectedObjects };
                                this.props.uploadSaveUploadedData(original);
                                this.props.saveLastCustomData({ id: this.props.user.id, groupid: this.props.user.groupid }, "lastuploaddata", original);
                            }
                        }
                        this.closeAllUploadWindows();
                    });
            }
            else {
                this.closeAllUploadWindows();
            }
        } else {
            this.closeUploadFormForApp();
        }
    }

    setFormState = () => {
        if (!this.state.formCancelling) {
            switch (this.props.formDesign) {
                case CustomTypes.ADD_FORM:
                    this.props.setAddFormState("closed");
                    break;
                case CustomTypes.SEARCH_FORM:
                    this.closeSearchForm();
                    break;
                case CustomTypes.MASTER_UPLOAD_FORM:
                case CustomTypes.UPLOAD_FORM:
                    this.startCloseUploadForm();
                    break;
                default:
                    break;
            }
            this.setState({ formCancelling: true });
        }
    };

    onCancel = () => {
        if (this.state.uploadStatus !== "uploading") {
            this.setState({ formCancelling: false }, () => this.setFormState());
        } else this.setFormState();
    }

    onCancelIcon = () => {
        if (!this.state.formCancelling) {
            this.setState({ shouldClose: true, uploadIconClicked: true }, () => this.setFormState());
        } else this.shouldCloseForm();
    }

    //MinMax BEGIN
    showTopIconsBox = () => {
        return (<div className={classes.CustomTopIconsBox}>
            {(this.props.formDesign === CustomTypes.UPLOAD_FORM)
                && DataUtil.isPMDB() && <CustomDataBox.CustomDataImage customStyle={CustomTypes.FILTER_1}
                    src={CustomAppEventListener(CustomEvents.GET_ICON, "minusIcon")} onClick={this.onMinIconClick} />}
            <CustomDataBox.CustomDataImage src={CustomAppEventListener(CustomEvents.GET_ICON, "cancelIcon")} onClick={this.onCancelIcon} />
        </div>)
    }

    checkAndResetShareDataForm = () => {
        const { shareDataForm } = this.props.shareObjects;
        if (shareDataForm && shareDataForm[`min${this.props.formDesign}`]) {
            this.props.updateShareObjects({ shareDataForm: { ...shareDataForm, [`min${this.props.formDesign}`]: false } });
        }
    }
    onMinIconClick = () => {
        const { shareDataForm } = this.props.shareObjects;
        this.setState({ formOverlay: CustomTypes.FORM_MIN, minPopUp: CustomTypes.DISPLAY_BLOCK });
        let formElm = document.getElementById("CustomDataDivId");
        formElm.style.display = "none";
        this.props.updateShareObjects({ shareDataForm: { ...shareDataForm, [`min${this.props.formDesign}`]: true } });
    }
    onMaxIconClick = () => {
        const { shareDataForm } = this.props.shareObjects;
        if (shareDataForm && shareDataForm[`min${this.props.formDesign}`]) {
            this.setState({ formOverlay: CustomTypes.FORM_MAX, minPopUp: CustomTypes.DISPLAY_NONE });
            let formElm = document.getElementById("CustomDataDivId");
            formElm.style.display = "block";
            this.props.updateShareObjects({
                shareDataForm: {
                    ...shareDataForm, [`min${this.props.formDesign}`]: false, [`click${this.props.formDesign}`]: false
                }
            });
        }
    }

    showMinMaxForm = (prevProps) => {
        const { shareDataForm } = this.props.shareObjects;
        if (shareDataForm &&
            !prevProps.shareObjects.shareDataForm[`click${this.props.formDesign}`] &&
            shareDataForm[`click${this.props.formDesign}`]
        ) {
            setTimeout(() => this.onMaxIconClick(), 100);
        }
    }

    checkMinMaxForm = () => {
        // if (this.props.showExpertSearch !== 'open' && !this.props.formState == 'open')
        if (this.props.showExpertSearch !== 'open')
            this.onMaxIconClick();
    }
    //MinMax END

    onSubmitBtn = (name) => {
        if (this.state.customDataObjects[name]) {
            if (this.props.customCurrentDialog === "project")
                this.props.saveNewProject(this.state.customDataObjects[name], true);
            else if (this.props.customCurrentDialog === "room") {
                let type = this.state.customDataObjects[`${name}type`] ? this.state.customDataObjects[`${name}type`] : "Download"
                this.props.saveNewRoom(this.state.customDataObjects[name], this.props.user.id, type);
            } else if (this.props.customCurrentDialog === name) {
                this.props[`savenew${name}`](this.state.customDataObjects[name]);
            }
            let msg = DataUtil.writeName(`${name} creating...`);
            DataUtil.showElementMsg(msg, this.state.pUploaded, "#d5001c");
            this.props.setCustomUploadInfo({ "isLoading": true });
            this.props.setAddFormState("closed");
        }
    }

    onDeleteFileIconClick = (divElementId) => {
        if (this.state.uploadStatus !== "uploading" && this.state.deleteIconOn === divElementId) {
            const { customDataObjects } = this.state;
            let selectedObjects = DataUtil.removeFileFromObjectData(divElementId, customDataObjects.selectedObjects, "url");
            selectedObjects = DataUtil.updateObjectData(selectedObjects);
            let fileId = selectedObjects.length;
            this.setState({ selectedObjects, fileId, customDataObjects: { ...customDataObjects, selectedObjects: selectedObjects } }, () => {
                DataUtil.setDefaultValueForList(selectedObjects);
            });

            if (DataUtil.isFrancetv() && this.state.disableAll) {
                if (!selectedObjects.length) this.toggleFields({ disabled: false });
            }
        }
    }

    onSelectedFileClick = (elementList, divElementId) => {
        if (this.state.uploadStatus !== "uploading") {
            DataUtil.showSelectedObject(elementList, divElementId);
            this.setState({ deleteIconOn: divElementId });
        }
    }

    clearUploadInfo = () => this.props.setCustomUploadInfo({ "clearInfo": true });
    clearSearchInfo = () => this.props.setCustomSearchInfo({ "clearInfo": true });

    onLogFileClick = () => {
        if (this.props.formDesign === CustomTypes.SEARCH_FORM) {
            if (this.props.customSearchInfo) showLogFile("Search Info", this.props.customSearchInfo, this.clearSearchInfo, this.props.intl.formatMessage);
            else showLogFile("Search Info", { "Search": "stop" }, this.clearUploadInfo, this.props.intl.formatMessage);
        } else {
            if (this.props.customUploadInfo) showLogFile("Upload Info", this.props.customUploadInfo, this.clearUploadInfo, this.props.intl.formatMessage);
            else showLogFile("Upload Info", { "UploadFileStatus": "stop" }, this.clearUploadInfo, this.props.intl.formatMessage);
        }
    }

    onDdDeleteClick = (ddname) => {
        this.setState({
            [`${ddname}_tmp`]: '',
            [`${ddname}_apptmp`]: '',
            customDataObjects: { ...this.state.customDataObjects, [`${ddname}`]: '' }
        })
    }

    onDDSelectAllClick = (item) => () => {
        if (item && item.data && item.data.length) {
            const { customDataObjects } = this.state;
            let lg = DataUtil.getLanguage(this.props.lg);
            let ddname = item.name;
            let updatedObjects = [...item.data];
            updatedObjects = updatedObjects.filter(el => el && el.ID && el.ID !== 'CustomFakeId')
            let elements = this.getDataString(updatedObjects, false, lg);
            let elementsIds = this.getDataString(updatedObjects, true, lg);
            this.setState({
                [`${ddname}Items`]: updatedObjects,
                [`${ddname}_apptmp`]: elementsIds,
                customDataObjects: { ...customDataObjects, [`${ddname}`]: elements, [`${ddname}_ids`]: elementsIds }
            });
        }
    }

    onFormContainerClick = (event) => { if (!event.target.name) this.closeAllDropDowns(); }

    onInputBtnClick = (name) => () => {
        if (isPorscheArchiv()) {
            const { advSearchObj } = this.props.flexObjects;
            this.setState({ stockOpened: true });
            this.props.updateFlexObjects({ advSearchObj: { ...advSearchObj, stockOpened: true, stockNameIds: `${name}_ids`, stockName: name } });
        }
    }
    onStockHandler = (values) => {
        const { advSearchObj } = this.props.flexObjects;
        const { customDataObjects } = this.state;
        let value = "", keywords = "";
        if (values && values.tags && values.tags.length > 0) value = values.tags.join(";");
        if (values && values.keywords && values.keywords.length > 0) keywords = values.keywords.join(";");
        this.setState({ customDataObjects: { ...customDataObjects, [advSearchObj.stockNameIds]: value, [advSearchObj.stockName]: keywords } });
    }

    showTypeFilter = () => {
        return (
            <TypeFilter
                hidden={!PH.showControl(this.props.config, Controls.CTL_TOOLBAR_MEDIATYPE_FILTER)}
                typeFilterLabel={this.props.intl.formatMessage({ id: "typeFilter.filetypes" })}
                key={this.props.config.language}
                toogleFilter={this.props.onToggleFilter}
                filter={this.props.filter} />
        )
    }

    showHeaderLeft = () => {
        if ((DataUtil.isTranscoder1() || DataUtil.isOriginTranscoder1())
            && this.props.formDesign === CustomTypes.SEARCH_FORM) {
            return (
                <div className={classes.TypeFilterWrapper}>
                    <div />
                    {this.showTypeFilter()}
                    {this.showTopIconsBox()}
                </div>
            )
        }
        if (isPorscheArchiv() && this.props.formDesign === CustomTypes.SEARCH_FORM) {
            return (<FlexSearchSave onFlexSearchSaveList={this.onFlexSearchSaveList}>
                {this.showTopIconsBox()}
            </FlexSearchSave>)
        }
        return this.showTopIconsBox()
    }


    onTargetDDCk = ({ item }) => (el) => {
        const { customDataObjects } = this.state;
        let ddvalue = el.name || '';
        if (isDZA()) {
            if (el.name == 'CustomFakeId') ddvalue = '';
            if (this.props.formDesign === CustomTypes.UPLOAD_FORM) {
                this.props.updateFlexObjects({ flexUpload: { ddname: item.name, ddvalue } });
            } else {
                this.props.updateFlexObjects({ flexMulti: { ddname: item.name, ddvalue } });
            }
        }
        this.setState({
            [item.name]: ddvalue,
            customDataObjects: { ...customDataObjects, [item.name]: ddvalue }
        });
    }

    showHeaderRight = () => {
        return (
            <div className={classes.LogoContainer}>
                <CustomDataBox.CustomLargeLogoSection formDesign={this.props.formDesign}
                    formTitle={this.props.formTitle} formIcon={this.props.formIcon}
                    masterClipTitle={this.props.masterClipTitle} masterClipId={this.props.masterClipId} />
                <div>
                    {(isPorscheArchiv() && this.props.formDesign === CustomTypes.SEARCH_FORM) && this.showTypeFilter()}
                </div>
            </div>
        )
    }

    renderFooter = () => {
        if (this.props.formDesign === CustomTypes.SEARCH_FORM)
            return (<div className={classes.CustomFormFooter}>
                <CustomDataBox.CustomSearchButtonsBoxWithSpinner fMsgIdSubmit="expertsearch.SearchBtn" fMsgIdCancel="customdata.cancelBtn"
                    submitImgSrc={CustomAppEventListener(CustomEvents.GET_ICON, "whitesearch")}
                    onLogFileClick={this.onLogFileClick} onSubmitClick={this.onExpertSearch} onCancelClick={this.onDiscardChanges} />
            </div>);

        return (<div className={classes.CustomFormFooter}>
            {(this.props.formDesign === CustomTypes.MASTER_UPLOAD_FORM) ?
                <CustomDataBox.CustomRightButtonsBox fMsgIdSubmit="customdata.uploadBtn" fMsgIdCancel="customdata.cancelBtn" submitImgSrc={CustomAppEventListener(CustomEvents.GET_ICON, "uploadIcon")} onSubmitClick={this.onUploadFile} onCancelClick={this.onCancel} formStatus={this.state.uploadStatus === 'uploading' ? true : null} />
                : <CustomDataBox.CustomCenterButtonsBox fMsgIdSubmit="customdata.uploadBtn" fMsgIdCancel="customdata.cancelBtn" submitImgSrc={CustomAppEventListener(CustomEvents.GET_ICON, "uploadIcon")} onSubmitClick={this.onUploadFile} onCancelClick={this.onCancel} formStatus={this.state.uploadStatus === 'uploading' ? true : null} />}
        </div>)
    }

    renderCustomWidgets = (data) => {
        {
            return data.map((item, i) => {
                if (!item.condition) item.condition = CustomTypes.CUSTOM_CONDITION;
                if (item.inputType === "CustomSubForm")
                    return (<div className={isNLW() ? classes.CustomGap : null}>
                        <CustomDataBox.CustomSubmenuBox formDesign={this.props.formDesign} fMsgId={item.lgMsId} display={this.state[`${item.name}SubFormShow`]} onSubmenuIconClick={this.onSubFormIconClick.bind(this, item.name)} />
                        <div className={classes.CustomSubFormContainerPMDB} style={{ display: this.state[`${item.name}SubFormShow`] ? this.state[`${item.name}SubFormShow`] : "block" }} >
                            {item.data.map(item => {
                                if (item.inputType === "CustomSubFormSection")
                                    return (<div className={classes.CustomSubFormBox} style={{ display: this.state[`${item.name}SectionShow`] ? this.state[`${item.name}SectionShow`] : "block" }}>
                                        {this.renderCustomWidgets(item.data)}
                                    </div>)
                            })}
                            <CustomDataBox.CustomMessageBox display={this.state.unlimitedMessageBox} fMsgId="data.unlimitedVideoUsage" />
                        </div>
                    </div>)
                if (item.inputType === 'CustomDataInput')
                    return <div className={classes.SubDivSetting}><CustomDataBox.CustomDataInput customdisplay={this.state[`${item.condition.name}_apptmp`]} condition={item.condition} isUpload={this.props.formDesign === CustomTypes.UPLOAD_FORM}
                        mandatory={item.mandatory} fMsgId={item.lgMsId} type={item.isNum ? 'number' : 'text'} addObj={item.addObj} name={item.name} value={this.state.isDeleted ? "" : this.state.customDataObjects[item.name]}
                        onChange={this.onHandleChange} onKeyPress={this.onKeyPress} requiredField={this.state[`${item.name}_isRequired`]} /></div>
                if (item.inputType === "CustomDataInputWithIcon")
                    return (<CustomDataBox.CustomDataInputWithIcon key={`${item.name}_${i}`} fMsgId={item.lgMsId} type="text" src={item.src} name={item.name} value={this.state.isDeleted ? "" : this.state.customDataObjects[item.name]} onChange={this.onHandleChange} />);
                if (item.inputType === "CustomDataInputWithBtn")
                    return (<CustomDataBox.CustomDataInputWithBtn onInputBtnClick={this.onInputBtnClick(item.name)} key={`${item.name}_${i}`} onDeleteClick={this.onDDIconDelete(item)}
                        fMsgId={item.lgMsId} type="text" src={item.src} name={item.name} value={this.state.isDeleted ? "" : this.state.customDataObjects[item.name]} onChange={this.onHandleChange} />);
                if (item.inputType === 'CustomDateGroup')
                    return <CustomDataBox.CustomDateGroup uiConfig={this.props.uiConfig ? this.props.uiConfig : null} fMsgId={item.lgMsId} label={item.label ? item.label : null}
                        minDate={item.minDate ? item.minDate : null} maxDate={item.maxDate ? item.maxDate : null} selectedFrom={this.state.customDataObjects[`${item.name}From`]} selectedTo={this.state.customDataObjects[`${item.name}To`]}
                        onChangeFrom={this.onDateChange.bind(this, `${item.name}From`)} onChangeTo={this.onDateChange.bind(this, `${item.name}To`)} lg={this.props.lg} />
                if (item.inputType === 'CustomDateTimeGroup')
                    return <CustomDataBox.CustomDateTimeGroup uiConfig={this.props.uiConfig ? this.props.uiConfig : null} fMsgId={item.lgMsId}
                        label={item.label ? item.label : null} selectedFrom={this.state.customDataObjects[`${item.name}_FromDateTime`]}
                        selectedTo={this.state.customDataObjects[`${item.name}_ToDateTime`]} lg={this.props.lg}
                        onChangeFrom={this.onDateTimeChange.bind(this, `${item.name}_FromDateTime`)}
                        onChangeTo={this.onDateTimeChange.bind(this, `${item.name}_ToDateTime`)}
                        nameIn={`${item.name}_InFromDateTime`} nameOut={`${item.name}_OutToDateTime`} selectedIn={this.state.customDataObjects[`${item.name}_InFromDateTime`] ? this.state.customDataObjects[`${item.name}_InFromDateTime`] : ""}
                        selectedOut={this.state.customDataObjects[`${item.name}_OutToDateTime`] ? this.state.customDataObjects[`${item.name}_OutToDateTime`] : ""}
                        onChangeIn={this.onTimeChange.bind(this, `${item.name}_InFromDateTime`)} onChangeOut={this.onTimeChange.bind(this, `${item.name}_OutToDateTime`)} />
                if (item.inputType === 'CustomDateTime')
                    return <CustomDataBox.CustomDateTime uiConfig={this.props.uiConfig ? this.props.uiConfig : null} fMsgId={item.lgMsId} label={item.label ? item.label : null}
                        selectedDate={this.state.customDataObjects[`${item.name}DateTime`]} onChangeDate={this.onDateTimeChange.bind(this, `${item.name}DateTime`)} />

                if (item.inputType === "CustomResizableTextArea")
                    return (<CustomDataBox.CustomResizableTextArea mandatory={item.mandatory} key={`key${item.name}${i}`} fMsgId={item.lgMsId} name={item.name}
                        value={this.state.isDeleted ? "" : this.state.customDataObjects[item.name]} onChange={this.onTextAreaHandleChange} rows={this.state[item.name + 'rows']} id={item.name + 'areaTxtId'}
                        requiredField={this.state[`${item.name}_isRequired`]} />);

                if (item.inputType == "CustomClassicDropdown")
                    return (<CustomDataBox.CustomClassicDropdown customdisplay={this.state[`${item.condition.name}_apptmp`]}
                        condition={item.condition} isUpload={this.props.formDesign === CustomTypes.UPLOAD_FORM} data={item.data}
                        mandatory={item.mandatory} fMsgId={item.lgMsId} name={item.name} value={this.state.isDeleted ? "" : this.state.customDataObjects[item.name]}
                        onClick={this.onTargetDDCk({ item })} onKeyPress={this.onKeyPress} requiredField={this.state[`${item.name}_isRequired`]} />)
                if (item.inputType === "CustomDropDown" && DataUtil.checkEnableFields(item.name, this.props.user.role, this.props.formDesign))
                    return (<CustomDataBox.CustomDropdownWithFadeBox customdisplay={this.state[`${item.condition.name}_apptmp`]} advanced={item.advanced} onDDSelectAllClick={this.onDDSelectAllClick(item)}
                        condition={item.condition} mandatory={item.mandatory} lg={this.props.lg} key={`key${item.name}${i}`} label={item.label ? item.label : null} sorted={item.sorted ? item.sorted : false} display={this.state[`${item.name}Show`] ? this.state[`${item.name}Show`] : "none"}
                        fMsgId={item.lgMsId} formatMessage={this.props.intl.formatMessage} inputType={item.inputType} onDeleteClick={this.onDDIconDelete(item)} onDdRemoveItems={this.onFadeBoxDropDownRemoveItems.bind(this, item.name)} onDdInputClick={this.onDropDownIconClick.bind(this, item.name, item.data)}
                        onDdInputChange={this.onFadeBoxDropDownDataChange.bind(this, item.name, item.data)} onDataClick={this.onFadeBoxDropDownDataHandleClick.bind(this, item.name, true)} inputValue={this.state.isDeleted ? "" : this.state[`${item.name}_tmp`]} name={item.name}
                        data={this.state[`selected${item.name}s`] ? this.state[`selected${item.name}s`] : item.data} dataItems={this.state[`${item.name}Items`] ? this.state[`${item.name}Items`] : []} requiredField={this.state[`${item.name}_isRequired`]} />)

                if (item.inputType === "CustomCheckBox")
                    return (<CustomDataBox.CustomCheckBox key={i} label={item.label ? item.label : null} fMsgId={item.lgMsId} type={item.type} name={item.name} value={this.state.customDataObjects[item.name]} onChange={this.onCheckBoxChange} checked={this.state[`${item.name}_checked`]} />);
                if (item.inputType === "CustomDropDownAndCheckBoxGroup")
                    return (<CustomDataBox.CustomDropDownAndCheckBoxGroup lg={this.props.lg} key={`key${item.name}${i}`} label={item.label ? item.label : null} sorted={item.sorted ? item.sorted : false} display={this.state[`${item.name}Show`] ? this.state[`${item.name}Show`] : "none"}
                        fMsgId={item.lgMsId} inputType={item.inputType} onDdInputClick={this.onDropDownIconClick.bind(this, item.name, item.data)} onDdInputChange={this.onDropDownDataChange.bind(this, item.name, item.data)} onDataClick={this.onDropDownDataHandleClick.bind(this, item.name)}
                        inputValue={this.state.isDeleted ? "" : this.state[`${item.name}_tmp`]} name={item.name} data={this.state[`selected${item.name}s`] ? this.state[`selected${item.name}s`] : item.data}
                        onCheckBoxChange={this.onDropDownAndCheckBoxChange.bind(this, item.name, item.checkboxData)} checked={this.state[`${item.name}_checked`]} requiredField={this.state[`${item.name}_isRequired`]} checkboxData={item.checkboxData} />);
                if (item.inputType === "CustomDropdownWithFadeBox")
                    return (<CustomDataBox.CustomDropdownWithFadeBox customdisplay={this.state[`${item.condition.name}_apptmp`]} advanced={item.advanced} onDDSelectAllClick={this.onDDSelectAllClick(item)}
                        condition={item.condition} mandatory={item.mandatory} lg={this.props.lg} key={`key${item.name}${i}`} label={item.label ? item.label : null}
                        sorted={item.sorted ? item.sorted : false} display={this.state[`${item.name}Show`] ? this.state[`${item.name}Show`] : "none"}
                        fMsgId={item.lgMsId} formatMessage={this.props.intl.formatMessage} inputType={item.inputType} onDeleteClick={this.onDDIconDelete(item)} onDdRemoveItems={this.onFadeBoxDropDownRemoveItems.bind(this, item.name)} onDdInputClick={this.onDropDownIconClick.bind(this, item.name, item.data)}
                        onDdInputChange={this.onFadeBoxDropDownDataChange.bind(this, item.name, item.data)} onDataClick={this.onFadeBoxDropDownDataHandleClick.bind(this, item.name, false)} inputValue={this.state.isDeleted ? "" : this.state[`${item.name}_tmp`]} name={item.name}
                        data={this.state[`selected${item.name}s`] ? this.state[`selected${item.name}s`] : item.data} dataItems={this.state[`${item.name}Items`] ? this.state[`${item.name}Items`] : []} requiredField={this.state[`${item.name}_isRequired`]} />)

                if (item.inputType === "CustomCheckBoxList")
                    return (<CustomDataBox.CustomCheckBoxList lg={this.props.lg} fMsgId={item.lgMsId} name={item.name} type="checkbox" onChange={this.onCheckBoxListChange.bind(this, item.name)} data={item.data} mandatory={item.mandatory} checkedData={this.state[`${item.name}Items`] ? this.state[`${item.name}Items`] : []} />)
                if (item.inputType === "CustomMessageBox")
                    return (<CustomDataBox.CustomMessageBox display={true} fMsgId={item.lgMsId} />)
                if (item.inputType === "CustomTimeGroup")
                    return (<CustomDataBox.CustomTimeGroup nameIn={item.nameIn} nameOut={item.nameOut} fMsgId={item.lgMsId} selectedIn={this.state.customDataObjects[item.nameIn] ? this.state.customDataObjects[item.nameIn] : ""} selectedOut={this.state.customDataObjects[item.nameOut] ? this.state.customDataObjects[item.nameOut] : ""}
                        onChangeIn={this.onTimeChange.bind(this, item.nameIn)} onChangeOut={this.onTimeChange.bind(this, item.nameOut)} onClickIn={this.onClickIn} onClickOut={this.onClickOut} />)
                if (item.inputType === "CustomTextArea")
                    return (<CustomDataBox.CustomTextArea key={`key${item.name}${i}`} fMsgId={item.lgMsId} name={item.name} value={this.state.isDeleted ? "" : this.state.customDataObjects[item.name]} onChange={this.onTextAreaHandleChange}
                        rows={this.state[item.name + 'rows']} id={item.name + 'areaTxtId'} />);
                if (item.inputType === "CustomDateBox")
                    return (<CustomDataBox.CustomDateBox uiConfig={this.props.uiConfig ? this.props.uiConfig : null} fMsgId={item.lgMsId} label={item.label ? item.label : null} mandatory={item.mandatory} requiredField={this.state[`${item.name}_isRequired`]}
                        name={item.name} selectedDate={this.state.customDataObjects[item.name]} onChangeDate={this.onDateChange.bind(this, item.name)} lg={this.props.lg}
                        minDate={item.minDate ? item.minDate : null} maxDate={item.maxDate ? item.maxDate : null} />);

                if (item.inputType === 'CustomFlexDateGroup') {
                    return (<FlexDate fMsgId={item.lgMsId} item={item} onFlexDate={this.onFlexDate} mandatory={item.mandatory} requiredField={this.state[`${item.name}_isRequired`]} />)
                }
                if (item.inputType === "CustomDropDownWithAddButton")
                    return (<CustomDataBox.CustomDropDownWithAddButton isLoading={this.state[`dd${item.name}Loading`]} customdisplay={this.state[`${item.condition.name}_apptmp`]} condition={item.condition} mandatory={item.mandatory} onDeleteClick={this.onDdDeleteClick.bind(this, item.name)}
                        lg={this.props.lg} key={`key${item.name}${i}`} label={item.label ? item.label : null} sorted={item.sorted ? item.sorted : false} requiredField={this.state[`${item.name}_isRequired`]} display={this.state[`${item.name}Show`] ? this.state[`${item.name}Show`] : "none"}
                        fMsgId={item.lgMsId} inputType={item.inputType} onAddClick={this.onDropDownAddClick.bind(this, item.name)} onDdInputClick={this.onDropDownIconClick.bind(this, item.name, item.data)} onDdInputChange={this.onDropDownAddBtnDataChange.bind(this, item.name, item.data)}
                        onDataClick={this.onDropDownDataHandleClick.bind(this, item.name)} inputValue={this.state.isDeleted ? "" : this.state[`${item.name}_tmp`]} name={item.name} data={this.state[`selected${item.name}s`] ? this.state[`selected${item.name}s`] : item.data} />);
            })
        }
    }

    render() {
        const { formConfig } = this.props;
        if (this.props.formDesign === CustomTypes.ADD_FORM) return <div><div className={classes.CustomOverlay} />
            <div className={classes.CustomOverlayContainer}>
                {
                    formConfig.map((item, i) => {
                        if (!item.condition) item.condition = CustomTypes.CUSTOM_CONDITION;
                        if (item.inputType === 'CustomAddDataBox' && item.name === this.props.customCurrentDialog)
                            return <CustomDataBox.CustomAddDataBox lg={this.props.lg} heading={item.title} name={item.name} value={this.state[item.name]} fMsgId={item.lgMsId} fMsgIdSubmit={item.fMsgIdSubmit} fMsgIdCancel="customdata.cancelBtn" onSubmitClick={this.onSubmitBtn.bind(this, item.name)} onChange={this.onAddHandleChange.bind(this, item.name)} onCancelClick={this.onCancel} />
                        if (item.inputType === 'CustomAddDataBoxWithDropDown' && item.name === this.props.customCurrentDialog)
                            return <CustomDataBox.CustomAddDataBoxWithDropDown lg={this.props.lg} heading={item.title} name={item.name} value={this.state[item.name]} fMsgId={item.lgMsId} fMsgIdSubmit={item.fMsgIdSubmit} fMsgIdCancel="customdata.cancelBtn" onSubmitClick={this.onSubmitBtn.bind(this, item.name)} onChange={this.onAddHandleChange.bind(this, item.name)} onCancelClick={this.onCancel}
                                onDdChange={this.onAddHandleChange.bind(this, item.ddname)} ddfMsgId={item.ddlgMsId} ddvalue={this.state[item.ddname]} ddname={item.ddname} data={item.data} />
                    })
                }

            </div>
        </div>
        else
            return (
                <div className={classes.CustomOverlay} style={this.state.formOverlay}>
                    <div className={classes[`CustomMinPopUp${this.props.formDesign}`]} onClick={this.onMaxIconClick} style={this.state.minPopUp}></div>
                    <div style={this.props.formStyle ? this.props.formStyle : null} className={classes.CustomFormPage} id="CustomDataDivId"
                        onKeyDown={this.handleKeyPress} onKeyUp={this.handleKeyPress} onKeyPress={this.handleKeyPress} tabIndex="0">
                        <div className={classes.CustomFormContainer}>
                            <div className={(this.props.formDesign === CustomTypes.MASTER_UPLOAD_FORM) ? classes.CustomFormPromptsChild : classes.CustomFormPrompts}>
                                <div className={(this.props.formDesign === CustomTypes.SEARCH_FORM) ? classes.CustomFormScrollBox : classes.CustomFormMainBox} id="CustomFormMainBoxId" onKeyPress={this.onKeyPress}>
                                    <div className={classes.CustomFormHeader} id="CustomDataDivIdHeader" onMouseDown={this.onDragStart} >
                                        {this.showHeaderRight()}
                                        {this.showHeaderLeft()}
                                    </div>
                                    <div className={classes.CustomFormView} onClick={this.onFormContainerClick}>
                                        {(this.props.formDesign === CustomTypes.SEARCH_FORM) ?
                                            <div className={classes.CustomFormLeftSection}>
                                                {(Array.isArray(formConfig) && formConfig.length > 0) ? formConfig.map((submenu, index) => {
                                                    if (submenu && index < this.state.left_count) return (<div>
                                                        <CustomDataBox.CustomSubmenuBox formDesign={this.props.formDesign} fMsgId={submenu.lgMsId} display={this.state[`${submenu.name}SubmenuShow`]} onSubmenuIconClick={this.onSubmenuIconClick.bind(this, submenu.name)} />
                                                        <div className={classes.CustomFormSubmenu} style={{ display: this.state[`${submenu.name}SubmenuShow`] ? this.state[`${submenu.name}SubmenuShow`] : "block" }} >
                                                            {this.renderCustomWidgets(submenu.data)}
                                                        </div>
                                                    </div>)
                                                })
                                                    : null
                                                }
                                                <div className={classes.CustomSpaceBox}></div>
                                            </div>
                                            : <div className={classes.CustomFormLeftSection}>

                                                <div className={classes.CustomFormBodySection}>
                                                    <CustomDataBox.CustomSelectFilesButton formDesign={this.props.formDesign} onChangeFile={this.onChangeFile} />
                                                    <CustomDataBox.CustomDragDropUploadBox formDesign={this.props.formDesign} id={this.state.pUploaded} onClearFiles={this.onClearFiles} files={this.state.files} addFile={this.addFile}
                                                        customDataObjects={this.state.customDataObjects} onGetCheckedItem={this.onGetCheckedItem} uploading={this.props.pcObj.uploading} onAdvCheck={this.onAdvCheck(CustomTypes.OCR)} advName={CustomTypes.OCR}
                                                        onDeleteIconClick={this.onDeleteFileIconClick} onSelectedFileClick={this.onSelectedFileClick} onLogFileClick={this.onLogFileClick} uploadInfo={this.props.customUploadInfo} />
                                                </div>
                                                <div className={classes.CustomSpaceBox}></div>
                                            </div>
                                        }
                                        <div className={(this.props.formDesign === CustomTypes.SEARCH_FORM || this.props.formDesign === CustomTypes.MASTER_UPLOAD_FORM) ? classes.CustomFormRightSection : classes.CustomFormRightScrollSection}>
                                            <div className={classes.CustomFormBodySection}>
                                                <div className={this.props.formDesign === CustomTypes.MASTER_UPLOAD_FORM ? classes.CustomFormBox : null}>
                                                    {(Array.isArray(formConfig) && formConfig.length > 0) ? formConfig.map((submenu, index) => {
                                                        if ((submenu && this.props.formDesign !== CustomTypes.SEARCH_FORM) || (submenu && index > (this.state.left_count - 1) && this.props.formDesign === CustomTypes.SEARCH_FORM)) return (<div>

                                                            <CustomDataBox.CustomSubmenuBox formDesign={this.props.formDesign} fMsgId={submenu.lgMsId} display={this.state[`${submenu.name}SubmenuShow`]} onSubmenuIconClick={this.onSubmenuIconClick.bind(this, submenu.name)} />
                                                            <div className={classes.CustomFormSubmenu} style={{ display: this.state[`${submenu.name}SubmenuShow`] ? this.state[`${submenu.name}SubmenuShow`] : "block" }} >
                                                                {(DataUtil.isPMDB() && (submenu.name === CustomTypes.ADVANCED_METADATA) && this.props.formDesign === CustomTypes.UPLOAD_FORM) ?
                                                                    <div>
                                                                        {CustomConfig.sendEmail.map((item, i) => {
                                                                            if (!item.condition) item.condition = CustomTypes.CUSTOM_CONDITION;
                                                                            if (item.inputType === "CustomOutsideCheckBox")
                                                                                return (<CustomDataBox.CustomOutsideCheckBox key={i} label={item.label ? item.label : null} fMsgId={item.lgMsId} type={item.type} name={item.name} value={this.state.customDataObjects[item.name]} onChange={this.onCheckBoxChange} checked={this.state[`${item.name}_checked`]} />);
                                                                        })}
                                                                    </div> : null}
                                                                {((index === 0 && this.props.formDesign !== CustomTypes.SEARCH_FORM) || ((index == (this.state.left_count)) && this.props.formDesign === CustomTypes.SEARCH_FORM)) ? (<CustomDataBox.CustomClearAllBox formDesign={this.props.formDesign} fMsgId="data.requiredLb" onClearAllData={this.onClearAllData} />) : null}
                                                                {this.renderCustomWidgets(submenu.data)}
                                                            </div>
                                                        </div>)
                                                    }) : null}
                                                    <div className={classes.CustomSpaceBox}></div>
                                                    {(this.props.addFormState === 'open') ?
                                                        <CustomDataForm formDesign={CustomTypes.ADD_FORM}
                                                            setAddFormState={this.props.setAddFormState}
                                                            saveNewProject={this.props.saveNewProject}
                                                            saveNewRoom={this.props.saveNewRoom}
                                                            savenewdistribution={this.props.savenewdistribution}
                                                            saveneweventroom={this.props.saveneweventroom}
                                                            getCustomAppData={this.props.getCustomAppData}
                                                            user={this.props.user}
                                                            formConfig={CustomConfig.AddFormConfig}
                                                            lg={this.props.lg}
                                                            setCustomUploadInfo={this.props.setCustomUploadInfo}
                                                            customCurrentDialog={this.props.customCurrentDialog} /> : null}

                                                    {this.state.stockOpened && (
                                                        <StockWindow
                                                            {...this.props} show={this.state.stockOpened}
                                                            onSelect={(tags = [], keywords = []) => { }}
                                                            onClose={() => this.setState({ stockOpened: false })}
                                                            selected={[]} keywords={[]} onLoaded={(tags = [], keywords = []) => { }}
                                                            singleSelect={false}
                                                            changeHandler={this.onStockHandler}
                                                        />
                                                    )}

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {this.renderFooter()}
                            </div>
                        </div>
                    </div>
                </div>
            );
    }
}

const mapStateToProps = (state, ownProps) => {
    let pcObj = state.uploadFiles.pcObj;
    let uploadState = state.uploadFiles.uploadState;
    let customUploadInfo = state.customData.customUploadInfo;
    if (DataUtil.isUpMaster(ownProps.formDesign)) {
        pcObj = state.uploadFiles.pcObjMaster;
        customUploadInfo = state.customData.customUploadInfoMaster;
        uploadState = state.uploadFiles.uploadStateMaster;
    }

    return {
        lg: state.ui.language,
        projects: state.projects.projects,
        rooms: state.rooms.rooms,
        projectTree: state.projectTree.projectTree,
        distributions: state.distributions.distributions,
        eventrooms: state.eventRoomTree.projectTree,
        showUpload: state.ui.uploadState,
        pcObj: pcObj,
        uploadState: uploadState,
        apitags: state.ui.apiTags,
        apimodelle: state.ui.apiModels,
        uploadedObj: state.uploadFiles.uploadedObj,
        uploaders: state.admin.users,
        user: state.auth.user,
        searchedObj: state.ui.searchedObj,
        addFormState: state.customData.addFormState,
        newData: state.customData.newData,
        customHistory: state.customData.customHistory,
        customCurrentSortOption: state.customData.customCurrentSortOption,
        customCurrentDialog: state.customData.customCurrentDialog,
        customUploadInfo: customUploadInfo,
        customSearchInfo: state.customData.customSearchInfo,
        customAppData: state.customData.customAppData,
        customNewEntry: state.customData.customNewEntry,
        customLoadError: state.customData.customError,
        uiConfig: state.customData.customUiConfigForApp,
        articleObjects: state.article.articleObjects,
        shareObjects: state.share.shareObjects,
        showExpertSearch: state.ui.expertSearchState,
        formState: state.uploadFiles.formState,
        customFlexAppConfig: state.customData.customFlexAppConfig,
        config: state.ui.config,
        filter: state.ui.filter,
        flexTags: state.flex.flexObjects.flexTags,
        flexObjects: state.flex.flexObjects
    };
};
const mapDispatchToProps = (dispatch, ownProps) => {
    let uploadCancel;
    let uploadSetState;
    let isMaster = DataUtil.isUpMaster(ownProps.formDesign);
    if (isMaster) {
        uploadCancel = () => dispatch(actions.uploadCancel(ownProps.formDesign));
        uploadSetState = () => dispatch(actions.uploadSetStateMaster());
    } else {
        uploadCancel = () => dispatch(actions.uploadCancel());
        uploadSetState = () => dispatch(actions.uploadSetState());
    }
    let setCustomUploadInfo = (info) => {
        if (isMaster) dispatch(actions.setCustomUploadInfoMaster(info));
        else dispatch(actions.setCustomUploadInfo(info));
    };

    return {
        uploadFile: obj => dispatch(actions.uploadFile(obj)),
        createNewEntry: obj => dispatch(actions.uploadCreateNewEntry(obj)),
        setCustomInitialState: obj => dispatch(actions.setCustomInitialState(obj)),
        //uploadCancel: () => dispatch(actions.uploadCancel()),
        // uploadSetState: () => dispatch(actions.uploadSetState()),
        uploadCancel: uploadCancel,
        uploadSetState: uploadSetState,
        opened: () => dispatch(actions.uploadOpened()),
        closed: () => dispatch(actions.uploadClosed()),
        searchClosed: () => dispatch(actions.expertSearchClosed()),
        setAddFormState: (formState) => dispatch(actions.setAddFormState(formState)),
        saveSelectedTags: selectedTags => dispatch(actions.saveSelectedTags(selectedTags)),
        saveSelectedModels: selectedModels => dispatch(actions.saveSelectedModels(selectedModels)),
        uploadSaveUploadedData: uploadedObj => dispatch(actions.uploadSaveUploadedData(uploadedObj)),
        setupCustomForm: (formState) => dispatch(actions.uploadFormState(formState)),
        updateMetadata: (type, id, metadata) => dispatch(actions.updateMetadata(type, id, metadata)),
        expertSearchSaveData: (obj) => dispatch(actions.expertSearchSaveData(obj)),
        expertSearchSetupData: (obj) => dispatch(actions.expertSearchSetupData(obj)),
        saveNewProject: (newProjectTitle, isPrivate) => dispatch(actions.saveNewProjectForUpload(newProjectTitle, isPrivate)),
        sendEmail: (emailObj) => dispatch(actions.sendEmail(emailObj)),
        setNewData: (newData) => dispatch(actions.setNewData(newData)),
        saveLastCustomData: (userdata, option, lastCustomData) => dispatch(actions.saveLastCustomData4User(userdata, option, lastCustomData)),
        setCustomHistory: (currentHistory) => dispatch(actions.setCustomHistory(currentHistory)),
        setCurrentClip: () => dispatch(actions.selectClip(null)),
        setCurrentDialog: (data) => dispatch(actions.setCustomCurrentDialog(data)),
        saveNewRoom: (title, owner, type) => dispatch(actions.saveNewRoomForUpload({ title: title, owner: owner, roomtype: type })),
        setCustomCurrentSortOption: (option) => dispatch(actions.setCustomCurrentSortOption(option)),
        //setCustomUploadInfo: (info) => dispatch(actions.setCustomUploadInfo(info)),
        setCustomUploadInfo: setCustomUploadInfo,
        setCustomSearchInfo: (info) => dispatch(actions.setCustomSearchInfo(info)),
        getCustomAppData: (data, type) => dispatch(actions.getCustomAppData(data, type)),
        loadSeriesTree: () => dispatch(actions.getSeriesTree()),
        savenewdistribution: (data) => dispatch(actions.saveNewDistribution(data)),
        saveneweventroom: (data) => dispatch(actions.saveNewEventRoom(data)),
        updateShareObjects: (obj) => dispatch(actions.updateShareObjects(obj)),
        getCustomFlexAppConfig: (option) => dispatch(actions.getCustomFlexAppConfig(option)),
        onToggleFilter: (filter) => dispatch(actions.toggleFilter(filter)),
        updateFlexObjects: (obj) => dispatch(actions.updateFlexObjects(obj)),
        getFlexTags: () => dispatch(actions.getFlexTags()),
        loadProjectTree: () => dispatch(actions.getProjectTree()),
        loadRooms: () => dispatch(actions.getRooms()),
        loadEventRoomTree: () => dispatch(actions.getEventRoomTree()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(injectIntl(CustomDataForm)));
